import {cms3_moh,logo2,logo,Safi, wis_01, vernyuy_01, joy_1} from '../images'

export const generalStructuralData = [

  {
    learningTitle:"High Commander and Chief",
    companyHeadOfficeLocation:"Cameroon | Buea",
    logo:logo,

    companyLevel1:[
      {
        name:"Design - Suber Craftex",
        courseStatus:"Incomplete",

        courseNumber:"001",
        logo:logo2,
        menu:[
          {
            name:'Welcome To Msb Tutoring',
            detail:"This program is dedicated to providing the best information sources to take you from zero to a full-stack developer.",
            ancorName:"welcome"
          },
          {
            name:'Introduction',
            detail:"In this unit, we’ll learn about how the web works and start thinking about the basics of computer and web programming.\n Each of the following sections and lessons represents essential baseline knowledge. Even if you have no intention of becoming a web developer yourself, this material should help you gain a useful understanding of the moving parts involved in creating and serving content on the web.\n We will start by getting familiar with the internet and your own computer. Next, we’ll work on setting up a development environment and learning about Git and GitHub. Then, we’ll go over the basics of front-end technologies like HTML, CSS, and Javascript before stepping into the back end with a brief foray that covers the basic concepts of back-end technologies.\n By the end of this unit, you should not only understand how the web works but also be able to identify and differentiate between all the technologies that you will use to build your own web applications. You will be able to build a simple webpage, style it, and add minor elements of interactivity while working comfortably from the command line.\n This section intentionally covers a very broad range of topics. It’s silly to go diving straight into server-side programming without having a context for what it is and why it’s useful (and why you should learn it!).",
            ancorName:"introduction"
          },
          {
            name:'How It Works',
            detail:"This curriculum works by pulling together the best content from across the internet for learning a particular topic. In each lesson, we’ll introduce the topic and try to provide some useful context before pointing you to external resources made by others.\n Most lessons will contain questions that you should be able to answer before moving on. Some of the lessons will ask you to complete exercises. In addition, we provide several projects throughout the curriculum to help you grow your understanding by actually building things.\n Try not to think of programming, as a class in school. It’s not material you learn all at once to take a test, and then pass or fail. You can think of it as a snowball. You, yourself, are a snowball. You’re rolling down a hill full of snow and the further you roll; the more snow will stick to you. Sure, snow will also fall off you, and you’ll forget things often, but that’s just part of the process. Don’t be scared if you get to a project and you feel like you haven’t retained or memorized anything. That’s natural and happens to everyone. The information will come back to you as you start solving your problems one at a time, relying on Google and the Odin Community for help.",
            ancorName:"howItWorks"
          },
          {
            name:'A Note About Language',
            detail:"Please be aware that this curriculum is written in English and maintained by English speakers who are not able or expected to translate it for you. As you develop into a programmer, you will find that the world you are entering into is firmly rooted in the English language. This means that the syntax of your programming language, the documentation that teaches you how to use it, and the majority of the people in the community are all expecting to communicate with you in English.\nIf you are a non-English speaker, or English is not a primary language for you, this fact is not meant to discourage you, but to prepare you.\nAs another part of this preparation, we highly recommend spending extra time on topics and terms that you do not understand right away. We also encourage you to seek out additional resources that teach about these topics in your own native language so you can understand them more fully.\nIn addition to this, you might also consider using a translation dictionary in your own language alongside our curriculum so you can readily reference it as you go. We do not have any recommendations on these since there are such a wide variety of languages spoken throughout the world, finding one may perhaps be a good first step in learning how to find useful tools online by searching. This is a skill you will utilize and improve as you progress in your learning to be a developer.\n",
            ancorName:"language"
          },
          {
            name:'What Comes Next',
            detail:"Once you’ve completed this course, you should feel comfortable with the building blocks of web programming but itching to dig deeper. Though we spend a fair bit of time digging into each of the major topics in this course, it’s really just a taste of what comes next (and all the cool stuff you can do with it).\nThe last lesson of this course will give you an opportunity to choose between a Full Stack JavaScript and Full Stack Rails path, both of which are designed to take the foundation built in this course and build it into an applied understanding of the material. Each path will focus on taking these raw building blocks and honing them into a highly functional skillset.\nThis program is maintained by professionals. We have chosen some of the best resources available and curated a guide on how to go through them. If there are no good resources, we write our own. With that said, know that everything in the curriculum is intentionally included and vital for you to become a successful programmer.\nAs you move forward, in the curriculum each portion is built on everything that came before it, so skipping things will create pockets of non-understanding in your knowledge that start to affect your ability to solve problems and understand the task at hand.\nAdditional resources are the only thing that is considered optional unless explicitly stated. These are here in case you feel like you need or want to dive deeper into a topic to get a better understanding.\n DO NOT SKIP ANYTHING!",
            ancorName:"whatComesNext"
          }

        ],
        source:[
          {
            name:"TheodinProject",
            link:"https://www.theodinproject.com/lessons/foundations-how-this-course-will-work"
          }
        ],
        people:[ ],
        companyLevel2:[
          {
            name:"Love made",
            courseStatus:"Incomplete",
            
            courseNumber:"006",
            logo:logo2,
            menu:[
            {
            name:'Introduction',
            detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
            detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Introduction",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            
            ],
            additionalRead:[
            {
            title:"Watch Kevin Powell’s HTML Links Video.",
            url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
            },
            
            ],
            KnowledgeCheck:[
              {
                check:"What element is used to create a link?"
              },
              
            ],
            source:[
            {
            name:"TheodinProject",
            link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
            },
            {
            name:"download image ",
            link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
            },
            ],
            people:[],
            
          },
          {
            name:"girlfriend Cadidate",
            courseStatus:"Incomplete",
            
            courseNumber:"006",
            logo:logo2,
            menu:[
            {
            name:'Introduction',
            detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
            detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Introduction",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            
            ],
            additionalRead:[
            {
            title:"Watch Kevin Powell’s HTML Links Video.",
            url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
            },
            
            ],
            KnowledgeCheck:[
              {
                check:"What element is used to create a link?"
              },
              
            ],
            source:[
            {
            name:"TheodinProject",
            link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
            },
            {
            name:"download image ",
            link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
            },
            ],
            people:[],
            companyLevel3:[
              {
                name:"Yauonde",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[],
              },
              {
                name:"Douala",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[
                  // {
                  //   // name:'Safiyatu Siben',
                  //   //       photo:Safi,
                  //   //       title:'Talior',
                  //   //       phoneNumber:'+237 653289353',
                  //   //     email:"Unknown",
                  //   //     website:"Unkown",
                  //   //     address:"Douala",
                  //   //     linkedIn:"Unknown",
                  //   //     Education:[
                         
            
            
            
                  //   //     ],
                  //   //     languages:[
                  //   //       {
                  //   //         languageName:"English",
                  //   //         languagesPercent:"95%"
                  //   //       },
                         
                  //   //     ],
                  //   //     BiographyP1:'Currently a tailor in douala and got into saling rapper materials',
                  //   //     BiographyP2:"",
                  //   //     BiographyP3:"",
                  //   //     BiographyP4:"",
                  //   //     BiographyP5:"",
                  //   //     Experience:[
                  //   //       // {
                  //   //       //   yearsOfExperience:"May 2022 - Present",
                  //   //       //   placeOfExperience:"Camsol Technologies UG (haftungsbeschränkt) Full time",
                  //   //       //   locationOfExperience:"Germany",
                  //   //       //   areaOfExpertise:"Geschäftsführende Gesellschafterin(Managing Partner) | CEO",
                  //   //       //   descOfWorkDoneInAreaOfExpertise:"HR Leader, focused on providing strategic HR Partnering to Executive Vice President Applications. Focused on Optimising Business Performance, Executive Leadership, Organisation Design and Transformation. Responsible for leading a team of Senior HRBPs who align with Camsol based Executives (Senior Vice Presidents / Vice Presidents) within the License Organisation,",
                  //   //       // },
                         
            
            
                  //   //     ],
                  //   //     professionalSkills:[
                  //   //       // {
            
                  //   //       //   nameOfSkill:"SAP Developer at GoToSec GmbH",
                  //   //       //   persentageOfSkills:"95%",
                  //   //       // },
            
            
                  //   //     ],
                  //   //     Interest:[
                  //   //       {
                  //   //         // iconOfInterest:"",
                  //   //         // nameOfInterest:"",
                  //   //       }
                  //   //     ],
                  //   //     source:[
                  //   //       // {
                  //   //       //   name:"LinkedIn",
                  //   //       //   link:"https://www.linkedin.com/in/schererbraun/"
                  //   //       // },
                  //   //       // {
                  //   //       //   name:"Notion",
                  //   //       //   link:"https://www.notion.so/camsol/44d1d0a072624df9a5ab29d6bbc7b20a?v=c3a189c055474561b63f6a0a7741121e"
                  //   //       // },
            
                  //   //     ]
                  // },
                
                ],
              },
              {
                name:"Buea",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[
                  {
                    name:'Ngeh Wisdom ',
                          photo:wis_01,
                          title:'psychologist student',
                          phoneNumber:'+237 683574678(Ekra minette)',
                        email:"Unknown",
                        website:"Unkown",
                        address:"Douala",
                        linkedIn:"Unknown",
                        Education:[
                         
            
            
            
                        ],
                        languages:[
                          {
                            languageName:"English",
                            languagesPercent:"95%"
                          },
                         
                        ],
                        BiographyP1:'I choose psychology because I love working with people',
                        BiographyP2:"i sent her 500 on 02-06-2025 for transport",
                        BiographyP3:"",
                        BiographyP4:"",
                        BiographyP5:"",
                        Experience:[
                          // {
                          //   yearsOfExperience:"May 2022 - Present",
                          //   placeOfExperience:"Camsol Technologies UG (haftungsbeschränkt) Full time",
                          //   locationOfExperience:"Germany",
                          //   areaOfExpertise:"Geschäftsführende Gesellschafterin(Managing Partner) | CEO",
                          //   descOfWorkDoneInAreaOfExpertise:"HR Leader, focused on providing strategic HR Partnering to Executive Vice President Applications. Focused on Optimising Business Performance, Executive Leadership, Organisation Design and Transformation. Responsible for leading a team of Senior HRBPs who align with Camsol based Executives (Senior Vice Presidents / Vice Presidents) within the License Organisation,",
                          // },
                         
            
            
                        ],
                        professionalSkills:[
                          // {
            
                          //   nameOfSkill:"SAP Developer at GoToSec GmbH",
                          //   persentageOfSkills:"95%",
                          // },
            
            
                        ],
                        Interest:[
                          {
                            // iconOfInterest:"",
                            nameOfInterest:"I love playing football,Either a goal keeper or a defender",
                          }
                        ],
                        source:[
                          // {
                          //   name:"LinkedIn",
                          //   link:"https://www.linkedin.com/in/schererbraun/"
                          // },
                          // {
                          //   name:"Notion",
                          //   link:"https://www.notion.so/camsol/44d1d0a072624df9a5ab29d6bbc7b20a?v=c3a189c055474561b63f6a0a7741121e"
                          // },
            
                        ]
                  },
                  {
                    name:'Mary Joy ',
                          photo:joy_1,
                          title:'student( doctor training)',
                          phoneNumber:'Unknown',
                        email:"Unknown",
                        website:"Unkown",
                        address:"Buea",
                        linkedIn:"Unknown",
                        Education:[
                         
            
            
            
                        ],
                        languages:[
                          {
                            languageName:"English",
                            languagesPercent:"95%"
                          },
                         
                        ],
                        BiographyP1:'',
                        BiographyP2:"",
                        BiographyP3:"",
                        BiographyP4:"",
                        BiographyP5:"",
                        Experience:[
                          // {
                          //   yearsOfExperience:"May 2022 - Present",
                          //   placeOfExperience:"Camsol Technologies UG (haftungsbeschränkt) Full time",
                          //   locationOfExperience:"Germany",
                          //   areaOfExpertise:"Geschäftsführende Gesellschafterin(Managing Partner) | CEO",
                          //   descOfWorkDoneInAreaOfExpertise:"HR Leader, focused on providing strategic HR Partnering to Executive Vice President Applications. Focused on Optimising Business Performance, Executive Leadership, Organisation Design and Transformation. Responsible for leading a team of Senior HRBPs who align with Camsol based Executives (Senior Vice Presidents / Vice Presidents) within the License Organisation,",
                          // },
                         
            
            
                        ],
                        professionalSkills:[
                          // {
            
                          //   nameOfSkill:"SAP Developer at GoToSec GmbH",
                          //   persentageOfSkills:"95%",
                          // },
            
            
                        ],
                        Interest:[
                          {
                            // iconOfInterest:"",
                            nameOfInterest:"",
                          }
                        ],
                        source:[
                          // {
                          //   name:"LinkedIn",
                          //   link:"https://www.linkedin.com/in/schererbraun/"
                          // },
                          // {
                          //   name:"Notion",
                          //   link:"https://www.notion.so/camsol/44d1d0a072624df9a5ab29d6bbc7b20a?v=c3a189c055474561b63f6a0a7741121e"
                          // },
            
                        ]
                  },
                ],
              },
              {
                name:"Limbe",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[],
              },
            ]
          },
          {
            name:"Business Contacts",
            courseStatus:"Incomplete",
            
            courseNumber:"006",
            logo:logo2,
            menu:[
            {
            name:'Introduction',
            detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
            detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Introduction",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            
            ],
            additionalRead:[
            {
            title:"Watch Kevin Powell’s HTML Links Video.",
            url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
            },
            
            ],
            KnowledgeCheck:[
              {
                check:"What element is used to create a link?"
              },
              
            ],
            source:[
            {
            name:"TheodinProject",
            link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
            },
            {
            name:"download image ",
            link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
            },
            ],
            people:[],
            companyLevel3:[
              {
                name:"Yauonde",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[],
              },
              {
                name:"Douala",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[
                  {
                    name:'Safiyatu Siben',
                          photo:Safi,
                          title:'Talior',
                          phoneNumber:'+237 653289353',
                        email:"Unknown",
                        website:"Unkown",
                        address:"Douala",
                        linkedIn:"Unknown",
                        Education:[
                         
            
            
            
                        ],
                        languages:[
                          {
                            languageName:"English",
                            languagesPercent:"95%"
                          },
                         
                        ],
                        BiographyP1:'Currently a tailor in douala and got into saling rapper materials',
                        BiographyP2:"Yes am married but am not with my husband right, Yes am having 4 with twins",
                        BiographyP3:"",
                        BiographyP4:"",
                        BiographyP5:"",
                        Experience:[
                          // {
                          //   yearsOfExperience:"May 2022 - Present",
                          //   placeOfExperience:"Camsol Technologies UG (haftungsbeschränkt) Full time",
                          //   locationOfExperience:"Germany",
                          //   areaOfExpertise:"Geschäftsführende Gesellschafterin(Managing Partner) | CEO",
                          //   descOfWorkDoneInAreaOfExpertise:"HR Leader, focused on providing strategic HR Partnering to Executive Vice President Applications. Focused on Optimising Business Performance, Executive Leadership, Organisation Design and Transformation. Responsible for leading a team of Senior HRBPs who align with Camsol based Executives (Senior Vice Presidents / Vice Presidents) within the License Organisation,",
                          // },
                         
            
            
                        ],
                        professionalSkills:[
                          {
            
                            nameOfSkill:"seamstress",
                            persentageOfSkills:"75%",
                          },
            
            
                        ],
                        Interest:[
                          {
                            // iconOfInterest:"",
                            // nameOfInterest:"",
                          }
                        ],
                        source:[
                          // {
                          //   name:"LinkedIn",
                          //   link:"https://www.linkedin.com/in/schererbraun/"
                          // },
                          // {
                          //   name:"Notion",
                          //   link:"https://www.notion.so/camsol/44d1d0a072624df9a5ab29d6bbc7b20a?v=c3a189c055474561b63f6a0a7741121e"
                          // },
            
                        ]
                  },
                
                ],
              },
              {
                name:"Buea",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[
                  // {
                  //   // name:'Ngeh Wisdom ',
                  //   //       photo:wis_01,
                  //   //       title:'psychologist student',
                  //   //       phoneNumber:'+237 653289353',
                  //   //     email:"Unknown",
                  //   //     website:"Unkown",
                  //   //     address:"Douala",
                  //   //     linkedIn:"Unknown",
                  //   //     Education:[
                         
            
            
            
                  //   //     ],
                  //   //     languages:[
                  //   //       {
                  //   //         languageName:"English",
                  //   //         languagesPercent:"95%"
                  //   //       },
                         
                  //   //     ],
                  //   //     BiographyP1:'I choose psychology because I love working with people',
                  //   //     BiographyP2:"",
                  //   //     BiographyP3:"",
                  //   //     BiographyP4:"",
                  //   //     BiographyP5:"",
                  //   //     Experience:[
                  //   //       // {
                  //   //       //   yearsOfExperience:"May 2022 - Present",
                  //   //       //   placeOfExperience:"Camsol Technologies UG (haftungsbeschränkt) Full time",
                  //   //       //   locationOfExperience:"Germany",
                  //   //       //   areaOfExpertise:"Geschäftsführende Gesellschafterin(Managing Partner) | CEO",
                  //   //       //   descOfWorkDoneInAreaOfExpertise:"HR Leader, focused on providing strategic HR Partnering to Executive Vice President Applications. Focused on Optimising Business Performance, Executive Leadership, Organisation Design and Transformation. Responsible for leading a team of Senior HRBPs who align with Camsol based Executives (Senior Vice Presidents / Vice Presidents) within the License Organisation,",
                  //   //       // },
                         
            
            
                  //   //     ],
                  //   //     professionalSkills:[
                  //   //       // {
            
                  //   //       //   nameOfSkill:"SAP Developer at GoToSec GmbH",
                  //   //       //   persentageOfSkills:"95%",
                  //   //       // },
            
            
                  //   //     ],
                  //   //     Interest:[
                  //   //       {
                  //   //         // iconOfInterest:"",
                  //   //         nameOfInterest:"I love playing football,Either a goal keeper or a defender",
                  //   //       }
                  //   //     ],
                  //   //     source:[
                  //   //       // {
                  //   //       //   name:"LinkedIn",
                  //   //       //   link:"https://www.linkedin.com/in/schererbraun/"
                  //   //       // },
                  //   //       // {
                  //   //       //   name:"Notion",
                  //   //       //   link:"https://www.notion.so/camsol/44d1d0a072624df9a5ab29d6bbc7b20a?v=c3a189c055474561b63f6a0a7741121e"
                  //   //       // },
            
                  //   //     ]
                  // },
                ],
              },
              {
                name:"Limbe",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[],
              },
            ]
          },
          {
            name:"Current Canditates",
            courseStatus:"Incomplete",
            
            courseNumber:"006",
            logo:logo2,
            menu:[
            {
            name:'Introduction',
            detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
            detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Introduction",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            
            ],
            additionalRead:[
            {
            title:"Watch Kevin Powell’s HTML Links Video.",
            url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
            },
            
            ],
            KnowledgeCheck:[
              {
                check:"What element is used to create a link?"
              },
              
            ],
            source:[
            {
            name:"TheodinProject",
            link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
            },
            {
            name:"download image ",
            link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
            },
            ],
            people:[],
            companyLevel3:[
              {
                name:"Yauonde",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[
                  {
                    name:'Vernyuy Dîna',
                          photo:vernyuy_01,
                          title:'bilingual letters, grauduate',
                          phoneNumber:'+237 650058096(whatsapp)',
                        email:"Unknown",
                        website:"Unkown",
                        address:"Youonde",
                        linkedIn:"Unknown",
                        Education:[
                         
            
            
            
                        ],
                        languages:[
                          {
                            languageName:"English",
                            languagesPercent:"95%"
                          },
                         
                        ],
                        BiographyP1:'I did bilingual letters, grauduate',
                        BiographyP2:"she is strugling, because right now she just want work that will occupie her and",
                        BiographyP3:"I'm praying Allah to bless me with my soulmate,God fearing person and understanding, Friendly",
                        BiographyP4:"I'm originated from bamenda, I'm presently in yaoundé",
                        BiographyP5:"",
                        Experience:[
                          // {
                          //   yearsOfExperience:"May 2022 - Present",
                          //   placeOfExperience:"Camsol Technologies UG (haftungsbeschränkt) Full time",
                          //   locationOfExperience:"Germany",
                          //   areaOfExpertise:"Geschäftsführende Gesellschafterin(Managing Partner) | CEO",
                          //   descOfWorkDoneInAreaOfExpertise:"HR Leader, focused on providing strategic HR Partnering to Executive Vice President Applications. Focused on Optimising Business Performance, Executive Leadership, Organisation Design and Transformation. Responsible for leading a team of Senior HRBPs who align with Camsol based Executives (Senior Vice Presidents / Vice Presidents) within the License Organisation,",
                          // },
                         
            
            
                        ],
                        professionalSkills:[
                          // {
            
                          //   nameOfSkill:"SAP Developer at GoToSec GmbH",
                          //   persentageOfSkills:"95%",
                          // },
            
            
                        ],
                        Interest:[
                          {
                            // iconOfInterest:"",
                            nameOfInterest:"I'm passionate about cooking.",
                          }
                        ],
                        source:[
                          // {
                          //   name:"LinkedIn",
                          //   link:"https://www.linkedin.com/in/schererbraun/"
                          // },
                          // {
                          //   name:"Notion",
                          //   link:"https://www.notion.so/camsol/44d1d0a072624df9a5ab29d6bbc7b20a?v=c3a189c055474561b63f6a0a7741121e"
                          // },
            
                        ]
                  },
                ],
              },
              {
                name:"Douala",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[
                  {
                    name:'Vernyuy Dîna',
                          photo:vernyuy_01,
                          title:'bilingual letters, grauduate',
                          phoneNumber:'+237 650058096(whatsapp)',
                        email:"Unknown",
                        website:"Unkown",
                        address:"Youonde",
                        linkedIn:"Unknown",
                        Education:[
                         
            
            
            
                        ],
                        languages:[
                          {
                            languageName:"English",
                            languagesPercent:"95%"
                          },
                         
                        ],
                        BiographyP1:'I did bilingual letters, grauduate',
                        BiographyP2:"she is strugling, because right now she just want work that will occupie her and",
                        BiographyP3:"I'm praying Allah to bless me with my soulmate,God fearing person and understanding, Friendly",
                        BiographyP4:"I'm originated from bamenda, I'm presently in yaoundé",
                        BiographyP5:"",
                        Experience:[
                          // {
                          //   yearsOfExperience:"May 2022 - Present",
                          //   placeOfExperience:"Camsol Technologies UG (haftungsbeschränkt) Full time",
                          //   locationOfExperience:"Germany",
                          //   areaOfExpertise:"Geschäftsführende Gesellschafterin(Managing Partner) | CEO",
                          //   descOfWorkDoneInAreaOfExpertise:"HR Leader, focused on providing strategic HR Partnering to Executive Vice President Applications. Focused on Optimising Business Performance, Executive Leadership, Organisation Design and Transformation. Responsible for leading a team of Senior HRBPs who align with Camsol based Executives (Senior Vice Presidents / Vice Presidents) within the License Organisation,",
                          // },
                         
            
            
                        ],
                        professionalSkills:[
                          // {
            
                          //   nameOfSkill:"SAP Developer at GoToSec GmbH",
                          //   persentageOfSkills:"95%",
                          // },
            
            
                        ],
                        Interest:[
                          {
                            // iconOfInterest:"",
                            nameOfInterest:"I'm passionate about cooking.",
                          }
                        ],
                        source:[
                          // {
                          //   name:"LinkedIn",
                          //   link:"https://www.linkedin.com/in/schererbraun/"
                          // },
                          // {
                          //   name:"Notion",
                          //   link:"https://www.notion.so/camsol/44d1d0a072624df9a5ab29d6bbc7b20a?v=c3a189c055474561b63f6a0a7741121e"
                          // },
            
                        ]
                  },
                
                ],
              },
              {
                name:"Buea",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[
                 
                ],
              },
              {
                name:"Limbe",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[],
              },
            ]
          },
        ]
      },

      {
        name:"Gorvenment and Finance",
        courseStatus:"incomplete",
        courseNumber:"002",
        logo:logo2,
        menu:[
          {
            name:'What Do Web Developers Do?',
            detail:"In short, web developers build and maintain websites.\nWeb developers often work for clients who are trying to get their product or service onto the web. The work is typically very project focused and involves collaborating with a team that helps to coordinate the client’s needs into the end product. The client could be a tech company, an organization, or a government. The work could involve front-end, back-end, or full-stack web development.\nWeb development could be a good profession for you if you like solving logical problems, building useful things, and experimenting with new technologies. Web developers are in high demand, generally have a good work/life balance, and command comfortable salaries. Google your specific location to get a better sense of your local web development job opportunities.\n For more details, Wikipedia describes the breadth of the web development profession in their entry on web design.",
            ancorName:"WhatDoWebDevelopersDo",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1650456852/msbGeanologyProfilePics/wiki1_gwa5pf.png"
          },
          {
            name:'Types of Web Developers',
            detail:"Earlier, we mentioned that web development work could be in the front end, the back end, or the full stack. What exactly do these terms mean?\n The front end is the stuff you see on the website in your browser, including the presentation of content and user interface elements like the navigation bar. Front-end developers use HTML, CSS, JavaScript, and their relevant frameworks to ensure that content is presented effectively and that users have an excellent experience.\n The back end refers to the guts of the application, which live on the server. The back end stores and serves program data to ensure that the front end has what it needs. This process can become very complicated when a website has millions of users. Back-end developers use programming languages like Java, Python, and Ruby to work with data.\n Full-stack developers are comfortable working with both the front and back ends. At The Odin Project, we focus on teaching you full-stack development, covering all aspects of web development.\n For more detail, Udacity has a great blog post on this topic: 3 Web Dev Careers Decoded: Front-End vs Back-End vs Full Stack",
            ancorName:"TypesofWebDevelopers",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1650456962/msbGeanologyProfilePics/frontVsBackVsfullStack_o2ap9k.png"

          },
          {
            name:'Types of Careers',
            detail:"Now that you know about the different types of web developers, let’s cover what we mentioned earlier about the different types of clients and employers you may work with.\n Large tech companies, such as Google, Facebook, and Amazon, have very stringent hiring requirements. If you successfully meet these expectations, they offer excellent pay, benefits, and opportunities.\n Startups are a bit like the wild west. For a junior developer, it can feel like a trial by fire because of the pace of development. Startups often offer slightly lower salaries and require longer hours, but they may also offer equity in the company and highly unique environments.\nAs a freelancer, you could command a strong hourly wage and the freedom to schedule and design your own products. However, you would be responsible for getting your own work (which means less coding time), managing billing from clients (which can be difficult), and being solely responsible. Strong people skills are necessary for this path.\nAs a consultant for a web consultancy, you would give up some of your freelancing wage potential but be able to focus more on the code and less on the hustle. This option also provides a good work/life balance and pay.\nFinally, large, older companies still need web developers. These companies offer a good work/life balance, pay, and benefits but often move slower than a company that is highly focused on tech.",
            ancorName:"TypesofCareers"
          },
          {
            name:'Tools of the Trade',
            detail:"These are some of the basic tools you will use regularly. You may not know what they are now, but you most certainly will going forward.",
            ancorName:"ToolsoftheTrade"
          },
          {
            name:'Computer',
            detail:"A computer is an electronic device that manipulates information, or data. It has the ability to store, retrieve, and process data. You may already know that you can use a computer to type documents, send email, play games, and browse the Web. You can also use it to edit or create spreadsheets, presentations, and even videos.",
            ancorName:"whatComesNext",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1650457042/msbGeanologyProfilePics/computer_j4qktk.png"
          },
          {
            name:'Google',
            detail:"Google is a fully-automated search engine that uses software known as web crawlers that explore the web on a regular basis to find sites to add to our index. In fact, the vast majority of sites listed in our results aren't manually submitted for inclusion, but are found and added automatically when our web crawlers crawl the web.\n Google Search works in essentially three stages:\nCrawling: Google searches the web with automated programs called crawlers, looking for pages that are new or updated. Google stores those page addresses (or page URLs) in a big list to look at later. We find pages by many different methods, but the main method is following links from pages that we already know about.\nIndexing: Google visits the pages that it has learned about by crawling, and tries to analyze what each page is about. Google analyzes the content, images, and video files in the page, trying to understand what the page is about. This information is stored in the Google index, a huge database that is stored on many computers.\n Serving search results: When a user searches on Google, Google tries to determine the highest quality results. The 'best' results have many factors, including things such as the user's location, language, device (desktop or phone), and previous queries. For example, searching for 'bicycle repair shops' would show different answers to a user in Paris than it would to a user in Hong Kong. Google doesn't accept payment to rank pages higher, and ranking is done algorithmically.",
            ancorName:"google",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1650457279/msbGeanologyProfilePics/google_jaw3vq.png"
          },
          {
            name:'Text Editor',
            detail:"A text editor is a computer program that lets a user enter, change, store, and usually print text (characters and numbers, each encoded by the computer and its input and output devices, arranged to have meaning to users or to other programs). Typically, a text editor provides an 'empty' display screen (or 'scrollable page') with a fixed-line length and visible line numbers. You can then fill the lines in with text, line by line. A special command line lets you move to a new page, scroll forward or backward, make global changes in the document, save the document, and perform other actions. After saving a document, you can then print it or display it. Before printing or displaying it, you may be able to format it for some specific output device or class of output device. Text editors can be used to enter program language source statements or to create documents such as technical manuals.\nA popular text editor in IBM's large or mainframe computers is called XEDIT. In UNIX systems, the two most commonly used text editors are EMACS and Vi . In personal computer systems, word processor s are more common than text editors. However, there are variations of mainframe and UNIX text editors that are provided for use on personal computers. An example is KEDIT, which is basically XEDIT for Windows.",
            ancorName:"textEditor",

          },
          {
            name:'Command Line Interface (CLI)',
            detail:"Abbreviated as CLI, a Command Line Interface connects a user to a computer program or operating system. Through the CLI, users interact with a system or application by typing in text (commands). The command is typed on a specific line following a visual prompt from the computer. The system responds to the text, and the user may then type on the next command line that appears. Through this command and response interaction, the user is able to issue a series of commands, which are executed by the system or program. Systems and software can provide users with both CLI and Graphical User Interface (GUI) options.\nProgrammers, experienced computer users, or administrators may utilise a CLI. There are specific situations when typing text into the interface will provide faster results than simply using a GUI. Plus, CLIs can offer greater control over an operating system via succinct commands. Operating system (OS) command line interfaces are normally programs that come with the OS. There are software applications that only offer a CLI. This software delivers a prompt, the user responds, and the application reacts to the commands successively.",
            ancorName:"cli",

          },
          {
            name:'Stack Overflow',
            detail:"Stack Overflow is a question and answer website for professional and enthusiast programmers. It is the flagship site of the Stack Exchange Network, created in 2008 by Jeff Atwood and Joel Spolsky.",
            ancorName:"StackOverflow",

          },
          {
            name:'GIT',
            detail:"Git is a free and open source distributed version control system designed to handle everything from small to very large projects with speed and efficiency.Git is easy to learn and has a tiny footprint with lightning fast performance. It outclasses SCM tools like Subversion, CVS, Perforce, and ClearCase with features like cheap local branching, convenient staging areas, and multiple workflows.",
            ancorName:"GIT",

          },
          {
            name:'GitHub',
            detail:"GitHub, Inc. is a provider of Internet hosting for software development and version control using Git. It offers the distributed version control and source code management functionality of Git, plus its own features.",
            ancorName:"GitHub",
          },
          {
            name:'Motivation',
            detail:"Learning to code is incredibly rewarding but can also be difficult and frustrating. The strongest assets you can have as a student are a desire to build, a problem-solving mind, and persistence in the face of setbacks.\n The web development industry has a long history of successful developers with varying backgrounds, so people tend to care more about what you’ve actually built than how you got there.",
            ancorName:"Motivation",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1650457765/msbGeanologyProfilePics/multivation_qc9xlq.png"
          },
          {
            name:'Conclusion',
            detail:"Hopefully, you’ve gained a better idea of what a web developer actually does and what your life might look like if you decided to take it on as a career. This has only been a teaser into the world of web development.\nIn this course, “Foundations” you’ll take a journey through the entire spectrum of topics that you will eventually need to know. This course jumps around to a variety of topics that you may be totally unfamiliar with, providing you a small taste of each and then moving on.\nThe following courses will dive deep into these topics. You will build dozens of scripts, projects, and websites to cement those skills that will get you hired. Getting all the way there is going to be challenging. In fact, you should check out the post “Why Learning to Code is So Damn Hard” so you have a good idea of what the journey ahead is like. But what worthwhile thing is truly easy?",
            ancorName:"Conclusion",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1650458160/msbGeanologyProfilePics/whysohard_hisblw.png"
          }


        ],
        additionalRead:[
          {
            title:"Quora: How can I Become a Really Good Web Developer?",
            url:"https://www.quora.com/Computer-Programming/How-can-I-become-a-really-good-web-developer-starting-from-now-at-age-20-before-age-25"
          },

          {
            title:"Quora: What makes a great web developer?",
            url:"https://blog.bitsrc.io/best-practices-in-using-iframes-with-react-6193feaa1e08"
          },
          {
            title:"Jared the Nerd: What makes a good web developer?",
            url:"https://jaredthenerd.com/2013/05/what-makes-a-good-developer/"
          },
          {
            title:"FreeCodeCamp: Things I Wish Someone Had Told Me When I Was Learning How To Code",
            url:"https://www.freecodecamp.org/news/things-i-wish-someone-had-told-me-when-i-was-learning-how-to-code-565fc9dcb329/"
          },
          {
            title:"TechCrunch: Don’t Believe Anyone who Tells you Learning to Code is Easy",
            url:"https://techcrunch.com/2014/05/24/dont-believe-anyone-who-tells-you-learning-to-code-is-easy/"
          },
          {
            title:"Code Quizzes: Deliberate Programming Practice",
            url:"https://codequizzes.wordpress.com/2013/04/28/deliberate-programming-practice/"
          },
          {
            title:"Roadmap to becoming a web developer in 2022",
            url:"https://github.com/kamranahmedse/developer-roadmap"
          },


        ],
        source:[
          {
            name:"TheodinProject",
            link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
          },
          {
            name:"Entry on web design wikipedia",
            link:"https://en.wikipedia.org/wiki/Web_design"
          },
          {
            name:"Frontend VS Backend Vs FullStack",
            link:"https://www.udacity.com/blog/2020/12/front-end-vs-back-end-vs-full-stack-web-developers.html"
          },
          {
            name:"Computer",
            link:"https://edu.gcfglobal.org/en/computerbasics/what-is-a-computer/1/"
          },

          {
            name:"Computer on wikipedia",
            link:"https://en.wikipedia.org/wiki/Computer"
          },
          {
            name:"Google",
            link:"https://developers.google.com/search/docs/basics/how-search-works"
          },
          {
            name:"Git",
            link:"https://git-scm.com/"
          },
          {
            name:"Stack Overflow",
            link:'https://stackoverflow.com/'
          },
          {
            name:"github",
            link:"https://github.com/"
          }
          ,
          {
            name:"Thinkful",
            link:"https://www.thinkful.com/blog/why-learning-to-code-is-so-damn-hard/"
          }
        ],
        people:[]
      },

      {
        name:"Food",
        courseStatus:"incomplete",
        courseNumber:"003",
        logo:logo2,
        menu:[
          {
            name:'Introduction',
            detail:"Learning to code is incredibly rewarding but can also be difficult and frustrating. Like any skill worth knowing, it takes time to acquire, and it can’t be learned in a weekend or even a month. With that said, we believe anyone can learn how to program as long as they are willing to put in the time and effort.\nSo before we get into the meat of the curriculum, we’re going to go over the following to help you get the most out of This curriculum: the things that will help you succeed in your goal of learning to code and the pitfalls that you should try to avoid.",
            ancorName:"Introduction",

          },

          {
            name:'Motivation',
            detail:"Take a moment to think about why you have decided to learn programming.==>Do you want to have a fulfilling career that pays well?==>Are you excited by the creative outlet programming provides? ==>Are you determined to develop the skills and abilities to build any app you can think of? ==>Do you want to start your own company by turning an app idea into reality?.\nYour motivation could be a combination of these reasons or something else entirely. Whatever it is, hold on tightly to your motivation - this will be what pulls you through to the end of this journey, giving you a definitive goal to aim towards.To give your motivation a bit of a boost, you can read about the success of others:",
            ancorName:"Motivation",
            popup1Name:"A woman who taught herself enough to land a job in 5 months",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1650455934/msbGeanologyProfilePics/woman_that_learn_cooding_ccguen.png",

            // popup2Name:"A 32 year old who taught himself programming using The Odin Project",
            // popup2:"",
          },

          {
            name:'Growth Mindset',
            detail:"Your mindset is very important when teaching yourself any new skills, not just programming. Your mindset will have more of an impact on your chances of success than just about anything else.Someone with the fixed mindset believes if they don’t get something on their first attempt, they never will. They believe that they simply aren’t smart enough to be able to do or understand some things.\nHowever, there is a wide body of research showing that intelligence is not fixed but can instead be developed. Someone with the growth mindset believes they can get better at anything with effort and persistence.What does this mean for you? It means you can learn new skills and develop new talents with persistence and grit.\nThere will be many times throughout The Project that you will get stuck on a concept or a programming problem and may find yourself questioning your ability to learn programming. When you find yourself in this position, remind yourself that you may not get it yet but that with persistence and grit you will. Struggling with something is growth. It doesn’t matter how long you struggle with a concept or project; all that matters is that you have the grit and tenacity to see it through. That’s how real learning happens.While you’re working through the curriculum, embrace the struggles you encounter with difficult concepts and complex projects. Be sure to celebrate your persistence at overcoming those struggles!\nWhen you find yourself questioning your abilities, reflect on the successes you have already achieved while learning to program: the projects you have completed and the concepts you once didn’t understand but now do. This is all the proof you need that you can do it.\nTo learn more about the growth mindset, check out these resources:",
            ancorName:"GrowthMindset",

          },

          {
            name:'The Learning Process',
            detail:"Learning concepts and then practicing them will help you to more fully understand how things work and fit together. Projects are the ultimate method for ensuring that your theoretical understanding aligns with how the programming concepts and techniques actually operate.\nWhen learning, your mind will consistently switch between focus mode and diffuse mode. Focus mode occurs when you are consciously focusing on learning, reading, watching videos, or working on a project. Diffuse mode occurs subconsciously, at times when you are not actively learning, such as when you’re doing the dishes, exercising, or sleeping. In this state, your mind goes about the business of connecting what you have been learning to the other things you know. This is where breakthroughs happen.\nIt’s important to know that your mind goes through these two states when learning because you can utilise this to make your learning more efficient. When stuck on a concept or project, taking a break to refresh and let your subconscious work on making connections more often than not yields a solution to your problem. The trick is to put effort into solving the problem first and then take a break.\nIn short, understand it, practice it, and finally teach it.\nTeaching what you know to others is a great way to solidify what you have learned and can often reveal holes in your knowledge that you wouldn’t have identified otherwise.\nYou can practice this method of learning by helping others in our community.(the odin project community)",
            ancorName:"TheLearningProcess",
            popup1Name:"To learn more about the best ways to learn, learning how to learn on Coursera is highly recommended",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1650455929/msbGeanologyProfilePics/corsera_learn_howtolearn_i8dv86.png",

            // popup2Name:"The Ruby Rogues have a podcast on How to Learn, which should be motivational and useful to you, so check it out for some useful thoughts on learning.",
            // popup2:"",
          },
          {
            name:'What To Do When You’re Stuck',
            detail:"You will inevitably get stuck at some point in the curriculum, perhaps due to a concept that you are having difficulty understanding or perhaps due to something not working correctly in a project. Whatever it is, use the following tools to get unstuck:\n==>Google it: You can be certain someone else out there has encountered the same problem as you at some point. A quick Google search can often lead to a solution.\n==>Take a break: Allow your diffuse learning state to work on the problem.\n==>Come prepared with your research on Developer Chats. People will be more willing to help you when they can see you have already put effort into trying to figure out the solution on your own",
            ancorName:"WhatToDoWhenYou’reStuck",

          },
          {
            name:'Managing Your Study Time',
            detail:"You will have more success with Odin by putting consistent time into it rather than working on it once a week. Building a habit of studying every day at a specific time and with a specific goal will ensure that you make consistent progress.\nIt may take you longer than others to grasp concepts, or it may take you less time. This doesn’t mean you’re smarter or dumber than others, it means you’ve had differing life experiences that may or may not have prepared you for learning this stuff. Someone who grew up around an engineer may have some advantages over someone who didn’t, but it doesn’t mean you can’t learn those skills.\nThe Odin Project isn’t like college or university, it is self paced and allows you to get a really solid grasp of concepts before moving on. In school, you’re forced to keep up or you will fail. The difference here is that coming into The Odin Project, you’re not expected to have much knowledge; there are no prerequisites. We’ve had people be successful coming through here that only knew how to check their email with a computer. We’ve also seen success from computer science degree holders. Treating The Odin Project like a static timeline is understandable, but is a sign of misplaced expectations. You simply don’t know what you don’t know yet, and that’s OK! There’s no due-dates on things in The Odin Project so you can spend the time to do it right and discuss the topics.\nDeadlines cause un-needed stress. Since The Odin Project is a free and open platform, you are not beholden to a deadline. Creating your own deadlines is a good way to rush concepts that should not be rushed. This course is very research based, meaning you will have to do research to complete tasks and projects. There’s no telling if you can find the article or post that helps you in the right way, quickly to meet your deadlines, but I bet you learned a TON along the way that you can use in the future. People that do this kind of research and strive to write better solutions tend to become better developers in the future. There’s no knowing how long it could take you to learn how to query stuff to find your answers. There are no solid guidelines on that. If you’re doing The Odin Project because you need a high paying job right-now, you’re not going to become a solid developer within the timeframe you have set. Stress and anxiety absolutely do not help you learn either. Relax and just enjoy the ride.\nLong story short: Don’t worry, just go learn",
            ancorName:"ManagingYourStudyTime",

          },

          {
            name:'Pitfalls to Avoid',
            detail:"The following are some of the pitfalls that beginners often encounter when learning how to program. Try your best to avoid these.\n==>Procrastination::Procrastination will be your biggest enemy when trying to make progress.==>Solution:: The Pomodoro Technique(The Pomodoro Technique is a time management method developed by Francesco Cirillo in the late 1980s.[1] It uses a timer to break work into intervals, typically 25 minutes in length, separated by short breaks. Each interval is known as a pomodoro, from the Italian word for tomato, after the tomato-shaped kitchen timer Cirillo used as a university student.) is a way of managing your time in order to stay focused. The idea is to set a timer for 25 minutes and to work on a task until the timer goes off. If you get distracted or interrupted during the 25 minutes, start the 25 minutes of work over again. Once you’ve successfully focused on work for 25 minutes, take a 5 minute break. When your break is over, repeat the 25 minutes of work and 5 minute break. After you’ve completed four 25 minute blocks of work, take a longer 15-30 minute break.\nThe Pomodoro technique is great for avoiding procrastination as it forces you to work without distractions. Since the work time only lasts 25 minutes before taking a break, it’s not overwhelming, making it harder to rationalize procrastination.",
            ancorName:"PitfallstoAvoid",

          },

          {
            name:'Not Taking Breaks',
            detail:"As you get into the material, you may feel compelled to continuously study for long periods of time. It might seem like you are getting more work done at first, but this often leads to burnout, which consequently results in lower productivity.\nIt may seem counterintuitive, but you will actually get more done if you regularly step back to recharge your brain and body. Studies show that performance increases after breaks of all durations: from extended vacations down to microbreaks of 30 seconds. John Trougakos, Associate Professor of Management at the University of Toronto, says that mental concentration is similar to a muscle. Our focus becomes fatigued after sustained use and needs a rest period to recover, just like a bodybuilder resting between sets at the gym.\n==>Solution: Use the previously mentioned Pomodoro Technique to time how often and how long to take your well-deserved breaks. Feel free to play around and experiment with different frequencies and durations of breaks.\nWhat to do during your break: ==>1 listen to music ==>2 journal ==>3 doodle ==>4 meditate ==>5 play a quick game ==>3 go for a short walk outside",
            ancorName:"NotTakingBreaks",

          },

          {
            name:'Digital Distractions',
            detail:"Digital distractions are email and Facebook notifications and time-wasting websites, such as social media. These distractions break your focus and make procrastination tempting. Therefore, they should be avoided during study time.\n==>Solution: Turn off notifications and add a blocker to your internet to limit your time on distracting sites.",
            ancorName:"DigitalDistractions",

          },
          {
          name:'Physical Distractions',
          detail:"Physical distractions are distractions from your environment, like a TV in the background or other people talking. These distractions can be just as damaging to your focus as digital distractions.\n==>Solution: Find a quiet place to study where you can go to focus in your home. If that’s not an option, you can use noise cancelling headphones to block out noisy distractions in your environment.",
          ancorName:"PhysicalDistractions",

        },

        {
        name:'Rabbit Holes',
        detail:"Because we cover so much material on The Odin Project and link to so many high quality courses and tools, it is easy for students to get pulled into rabbit holes by spending time trying to learn all there is to know about a subject that they aren’t ready for or won’t benefit them much. We have put a lot of effort into structuring the curriculum so that all of the important things that you need to know about web development are covered exactly when you need to know them.\n==>Solution: Stick to the path laid out as much as possible. Try to limit time spent going down rabbit holes as these sidetracks can really ruin your momentum.",
        ancorName:"RabbitHoles",

      },

      {
      name:'Comparing Yourself to Others',
      detail:"Students often compare themselves to others who are farther along in their coding journey or have more experience. This is a recipe for depression and frustration.\nSolution: Only compare yourself to your past self. Have your abilities and knowledge improved from where you were last week, last month, or last year? Be proud of the progress that you’ve made!",
      ancorName:"ComparingYourselftoOthers",

    },

    {
    name:'Conclusion',
    detail:"Learning any new skill is a journey full of speed bumps and obstacles to be overcome. We hope that the principles laid out here will put you in a much better position to succeed and to get the most out of The Odin Project.\nWithout further ado, let’s jump in to learning web development!",
    ancorName:"Conclusion",

  },

        ],
        additionalRead:[
          {
            title:"A woman who taught herself enough to land a job in 5 months",
            url:"https://newcodegirl.blogspot.com/2015/04/i-made-it-job-contract-signed.html"
          },
          {
            title:"A 32 year old who taught himself programming using The Odin Project",
            url:"https://www.reddit.com/r/learnprogramming/comments/34r807/im_32_years_old_and_just_started_my_first/",
          },
          {
            title:"Believe you can get better",
            url:"https://www.ted.com/talks/carol_dweck_the_power_of_believing_that_you_can_improve",
          },
          {
            title:"Grit",
            url:"https://www.ted.com/talks/angela_lee_duckworth_grit_the_power_of_passion_and_perseverance"
          },
          {
            title:"You can learn anything",
            url:"https://www.khanacademy.org/college-careers-more/talks-and-interviews/talks-and-interviews-unit/conversations-with-sal/a/the-learning-myth-why-ill-never-tell-my-son-hes-smart"
          },
          {
            title:"coursera learn how to learn",
            url:"https://www.coursera.org/learn/learning-how-to-learn"
          },
          {
            title:"The Ruby Rogues have a podcast on How to Learn, which should be motivational and useful to you, so check it out for some useful thoughts on learning.",
            url:"https://web.archive.org/web/20211129082738/https://devchat.tv/ruby-rogues/131-rr-how-to-learn/"
          },

          {
            title:"To learn more about the Pomodoro Technique, read this great article.",
            url:"https://medium.com/life-hacks/more-productivity-with-the-pomodoro-technique-d7ce8926ec0c#.hcqsv37u4"
          },

          {
            title:"If you want to try it out, TomatoTimer is an easy-to-use Pomodoro timer.",
            url:"https://www.toptal.com/project-managers/tomato-timer"
          },


          {
            title:"Read this article for more information on breaks & productivity.",
            url:"https://simpleprogrammer.com/taking-breaks-will-boost-productivity/"
          },

          {
            title:"Managing inspiration and motivation",
            url:"https://markmanson.net/how-to-get-motivated"
          },

          {
            title:"Learning to code when it gets dark",
            url:"https://www.freecodecamp.org/news/learning-to-code-when-it-gets-dark-e485edfb58fd#.yjh0fehje"
          },

          {
            title:"Improve your typing skills with Keybr.com Use this keyboard trainer if you find your typing speed is holding you back. We recommend to spend 5 mins everyday after you start your PC.",
            url:"https://www.keybr.com/"
          },

          {
            title:"Practice typing with Monkeytype! A minimalistic, customisable typing website. Test yourself in various modes, track your progress and improve your typing speed. It has a great community and frequently receives new features. Even though it has so many features, the experience is still very polished.",
            url:"https://monkeytype.com/"
          },

          {
            title:"Why Procrastinators Procrastinate Learn about the Instant Gratification Monkey, Rational Decision Maker, Panic Monster, and how to navigate the Dark Playground.",
            url:"https://waitbutwhy.com/2013/10/why-procrastinators-procrastinate.html"
          },


        ],
        source:[
          {
            name:"TheodinProject",
            link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
          },
        ],
        people:[]
      },

      {
        name:"Research and Developement",
        courseStatus:"incomplete",
        courseNumber:"004",
        logo:logo2,
        menu:[
          {
            name:'Introduction',
            detail:"Along your programming journey, you will inevitably need to ask questions in an online coding community like ours, or in conversations with your colleagues. While asking questions may seem rather simple, in a programming environment it is essential to ask well formed questions with as much context as needed so you can get the most out of asking for help. In essence, “help others help you!” This lesson will provide you with the tools to effectively ask questions in communities such as our Discord chat, Stack Overflow, and in the workplace!",
            ancorName:"Introduction",

          },

          {
            name:'Lesson Overview',
            detail:"This section contains a general overview of topics that you will learn in this lesson.==>1.)Explain techniques for asking programming questions. ==>2.)Explain and avoid qualities of “bad” questions. ==>3.)Ask effective and well formed questions",
            ancorName:"lessonOvervie",

          },

          {
            name:'Tips for Getting The Best Help Possible. 1.)Always provide your code and the surrounding context.',
            detail:"You can ask theoretical, vague questions, but you’re going to get theoretical, vague answers that probably won’t be helpful to you and cause frustration on both ends as you and the person helping you dance around the real issue. The only time code doesn’t need to be provided is if you are asking a purely conceptual question outside of a specific project or code snippet. Additionally, provide as much context as is necessary, and zero in on the specific problem, such as pointing people to a specific function or line number in your code so people can give you the most relevant answers and quickly assist you.",
            ancorName:"tips1",

          },

          {
            name:'Ask about the problem at hand, not the solution itself.',
            detail:'A lot of learners ask exactly how to approach a given task or assignment in this curriculum, such as the below:“How do I complete Step 5 of the Rock Paper Scissors Assignment”? Keep in mind that you’re actually supposed to figure out how to solve the assignments yourself, and figuring out an approach is essential to your learning journey. A much better question might look like this:“Hey, I’m trying to return a string that displays the winner in Rock Paper Scissors, but I’m getting a syntax error on line 12. How can I fix this? Here’s my code.”  In sharing your attempt, people know what you’ve tried and won’t suggest things that might not have worked out for you. It also allows them to debug your current iteration of code, rather than sending you down a path that has you start all over again when you might be very close to a solution. Now, if you’re completely stuck with where to start, it’s completely fine to let people know that you’re stuck. Asking where you can start and what you can research to get on the right track empowers you to be able to resolve issues largely on your own in the future, and might even empower you to help others with the same issue later on. It is also recommended that you share your pseudo code so people can nudge you in the right direction or correct any misunderstandings you may have.',
            ancorName:"tips2",

          },

          {
            name:'Don’t take asking for more context to heart!',
            detail:'People who volunteer in coding communities are here to help! But a question you may feel is coherent and “obvious” probably isn’t if you are being asked for more context. While something may seem “obvious” to a beginner, it’s sometimes nowhere near “obvious” to an expert. An expert knows about many, many more situations that could cause an issue someone is experiencing, and would want to refrain from sending a learner down the wrong path. People take time out of their day to help, so make it as easy as possible for them to help you! There’s probably a good reason why they need more information, so trust their judgement and experience when they ask. Many people who help in coding chats are unpaid volunteers, and are in no way obligated to answer your query. But because they truly do want to help you, they will ask for more information when needed!',
            ancorName:"tips3",

          },

          {
            name:'Assignment 1',
            detail:'Read and bookmark this amazing article by Gordon Zhu. It is a great reference to refer to whenever you find yourself needing to ask for help, and you might find yourself solving your own problem as you think about the points listed in the article. The video linked in this article is no longer available but that is not an issue since we explain debugging in detail later in the curriculum.',
            ancorName:"Assignment1",
            popup1Name:"How to be great at asking coding questions",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1650455921/msbGeanologyProfilePics/ask_right_questions_gditlv.png",

            popup2Name:"Read about the “XY Problem”, which is a common pitfall programmers new or experienced alike fall into when asking questions.",
            popup2:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1650462433/msbGeanologyProfilePics/xyproblem_wnm8y4.png",
          },

          {
            name:'Assignment 2',
            detail:'While asking for help is encouraged, it’s important to avoid becoming a “help vampire” and be respectful of the communities or persons you are asking for help. This resource goes in depth to identify what a “help vampire” is, gives those who help others the tools to empower folks to ask questions effectively, and help the “help vampire” effectively.',
            ancorName:"Assignment2",
            popup1Name:"Help Vampires",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1650464104/msbGeanologyProfilePics/helpVampire_iulvxj.png",

            popup2Name:"Check out this article from the world’s most popular programming help resource, Stack Overflow.",
            popup2:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1650463759/msbGeanologyProfilePics/stackoverflow_t8k37v.png",

            },


        ],
        additionalRead:[
          {
            title:"amazing article by Gordon Zhu.",
            url:"https://medium.com/@gordon_zhu/how-to-be-great-at-asking-questions-e37be04d0603"
            },

        {
          title:"XY Problem",
          url:"https://xyproblem.info/"
          },
        {
          title:"How do I ask a good question?",
          url:"https://stackoverflow.com/help/how-to-ask"
          },
        {
          title:"Help Vampires",
          url:"https://slash7.com/2006/12/22/vampires/"
          },
        ],

        source:[
          {
            name:"TheodinProject",
            link:"https://www.theodinproject.com/"
          },
        ],
        people:[]
      },

      


    ],


  },
  {
    learningTitle:"General 1",
    businessTitle:"Suber Craftex",
    companyHeadOfficeLocation:"Cameroon | Buea",
    logo:logo2,
    companyLevel1:[
      {
        name:"Human Resouce",
        courseStatus:"Incomplete",

        courseNumber:"001",
        logo:logo2,
        menu:[
          {
            name:'Introduction',
            detail:"So here it is: it’s time to actually start making things. This section will teach you the basics of HTML and CSS, the two foundational building blocks of pretty much everything on the web.",
            detail1:"",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Introduction",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
          },

          {
            name:'Lesson Overview',
            detail:"This section contains a general overview of topics that you will learn in this lesson.",
            detail1:"Get a basic overview of HTML, CSS and how they work together.",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Lesson Overview",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
          },

          {
            name:'HTML and CSS',
            detail:"HTML and CSS are two languages that work together to create everything that you see when you look at something on the internet. HTML is the raw data that a webpage is built out of. All the text, links, cards, lists, and buttons are created in HTML. CSS is what adds style to those plain elements. HTML puts information on a webpage, and CSS positions that information, gives it color, changes the font, and makes it look great!",
            detail1:"If you want to get technical, HTML and CSS aren’t programming languages because they are only concerned with presenting information. They are not used to program any logic. JavaScript, which you will be learning in the next section, is a programming language because it’s used to make webpages do things. Yet, there is quite a lot you can do with just HTML and CSS, and you will definitely need them both. The following lessons focus on giving you the tools you need to be successful once you get to the JavaScript content as you continue through our curriculum!",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"HTML and CSS",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
          },

          {
            name:'Assignment',
            detail:"Read HTML vs CSS vs JavaScript. It’s a quick overview of the relationship between HTML, CSS, and JavaScript.",
            detail1:"",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Assignment",
            popup1Name:"HTML vs CSS vs JavaScript",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1651238585/msbGeanologyProfilePics/Html-css-js_mzjfnq.png",
            popup2Name:"",
            popup2:"",
          },
        ],
        KnowledgeCheck:[
          {
            check:"What do HTML and CSS stand for?"
          },
          {
            check:"Between HTML and CSS, which would you use for putting paragraphs of text on a webpage?"
          },
          {
            check:"Between HTML and CSS, which would you use for changing the font and background color of a button?"
          },

        ],
        additionalRead:[
          {
            title:"This FreeCodeCamp article goes into a little more depth than the assigned one. It covers things we’ll be teaching explicitly in later lessons though, so don’t worry about memorizing any of the details.",
            url:"https://www.freecodecamp.org/news/html-css-and-javascript-explained-for-beginners/"
          },
          {
            title:"Bookmark DevDocs.io. Read the “Welcome” message. Massive API documentation collection that even works offline. An essential collection of reference material for everything covered and more. (Maintained by FreeCodeCamp)",
            url:"https://www.freecodecamp.org/news/html-css-and-javascript-explained-for-beginners/"
          },
        ],
        source:[
          {
            name:"TheodinProject",
            link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
          },
        ],
        people:[
            
              
              {
                name:'Mohamad Siysinyuy Banbong',
                      photo:cms3_moh,
                      title:'Megaminds team lead(full stack developer)',
                      
              },
            
         
  ]
    },

    {
      name:"products",
      courseStatus:"Incomplete",

      courseNumber:"002",
      logo:logo2,
      menu:[
        {
          name:'Introduction',
          detail:"HTML (HyperText Markup Language) defines the structure and content of webpages. We use HTML elements to create all of the paragraphs, headings, lists, images, and links that make up a typical webpage. In this lesson, we will explore how HTML elements work.",
          detail1:"",
          detail2:"",
          detail3:"",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"Introduction",
          popup1Name:"",
          popup1:"",
          popup2Name:"",
          popup2:"",
        },
        {
          name:'Lesson Overview',
          detail:"This section contains a general overview of topics that you will learn in this lesson.",
          detail1:"Explain what HTML Tags are",
          detail2:"Explain what HTML elements are",
          detail3:"",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"Lesson Overview",
          popup1Name:"",
          popup1:"",
          popup2Name:"",
          popup2:"",
        },
        {
          name:'Elements and Tags',
          detail:"Almost all elements on an HTML page are just pieces of content wrapped in opening and closing HTML tags.",
          detail1:"Opening tags tell the browser this is the start of an HTML element. They are comprised of a keyword enclosed in angle brackets <>. For example, an opening paragraph tag looks like this: <p>.",
          detail2:"Closing tags tell the browser where an element ends. They are almost the same as opening tags; the only difference is that they have a forward slash before the keyword. For example, a closing paragraph tag looks like this: </p>.",
          detail3:"You can think of elements as containers for content. The opening and closing tags tell the browser what content the element contains. The browser can then use that information to determine how it should interpret and format the content.",
          detail4:"There are some HTML elements that do not have a closing tag. These are known as empty elements because they don’t wrap any content. We will encounter a few of these in later lessons, but for the most part, elements will have both opening and closing tags.",
          detail5:"HTML has a vast list of predefined tags that you can use to create all kinds of different elements. It is important to use the correct tags for content. Using the correct tags can have a big impact on two aspects of your sites: how they are ranked in search engines; and how accessible they are to users who rely on assistive technologies, like screen readers, to use the internet.",
          detail6:"Using the correct elements for content is called semantic HTML. We will explore this in much more depth later on in the curriculum.",
          ancorName:"Elements and Tags",
          popup1Name:"A full paragraph element looks like this:",
          popup1:"https://cdn.statically.io/gh/TheOdinProject/curriculum/5e4a39cf0c23dd96f988bbf8197a9370a50dc2c4/html_css/v2/foundations/html-foundations/imgs/element-diagram.png",
          popup2Name:"",
          popup2:"",
        },

        {
          name:'',
          detail:"",
          detail1:"",
          detail2:"",
          detail3:"",
          detail4:"",
          detail5:"",
          detail6:"",
          ancorName:"",
          popup1Name:"",
          popup1:"",
          popup2Name:"",
          popup2:"",
        },

      ],

      additionalRead:[
        {
          title:"vast list of predefined tags",
          url:"https://developer.mozilla.org/en-US/docs/Web/HTML/Element"
        },
        {
          title:"Watch Kevin Powell’s Introduction to HTML Video",
          url:"https://www.youtube.com/watch?v=LGQuIIv2RVA&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-"
        },
        {
          title:"Don’t Fear the Internet’s video about HTML",
          url:"http://www.dontfeartheinternet.com/02-html/"
        },
      ],
      KnowledgeCheck:[
        {
          check:"What is an HTML tag?"
        },
        {
          check:"What are the three parts of an HTML element?"
        },
      ],
      source:[
        {
          name:"TheodinProject",
          link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
        },
      ],
    people:[]
  },
    {
    name:"Tech",
    courseStatus:"Incomplete",

    courseNumber:"003",
    logo:logo2,
    menu:[
      {
        name:'Introduction',
        detail:"All HTML documents have the same basic structure or boilerplate that needs to be in place before anything useful can be done. In this lesson, we will explore the different parts of this boilerplate and see how it all fits together.",
        detail1:"",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        ancorName:"Introduction",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
      },
      
    ],
    additionalRead:[
      {
        title:"Watch and follow along to Kevin Powell’s brilliant Building Your First Web Page video",
        url:"https://www.youtube.com/watch?list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&t=93&v=V8UAEoOvqFg&feature=youtu.be"
      },
      {
        title:" HTML validator",
        url:"https://validator.w3.org/"
      },
      {
        title:" Read through this article about what charsets you should use with your HTML pages.",
        url:"https://www.bitdegree.org/learn/html-encoding"
      },
      {
        title:" If you wish, you can add the lang attribute to individual elements throughout the webpage. Read through this doc for a better understanding of the lang attribute.",
        url:"https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/lang"
      },
    ],
    KnowledgeCheck:[
      {
        check:"What is the purpose of the doctype declaration?"
      },
      {
        check:"What is the HTML element?"
      },
      {
        check:"What is the purpose of the head element?"
      },
      {
        check:"What is the purpose of the body element?"
      },
    ],
    source:[
      {
        name:"TheodinProject",
        link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
      },
    ],
  people:[]
},
    {
  name:"finance",
  courseStatus:"Incomplete",

  courseNumber:"004",
  logo:logo2,
  menu:[
    {
      name:'Incoming -- (30-05-2025) 5000 CFA',
      detail:"i did some work, installing the odoo project and running it demoing it Kome in the office",
      detail1:"because of the demo, he was impress and gave me 5000",
      detail2:"",
      detail3:"",
      detail4:"",
      detail5:"",
      detail6:"",
      ancorName:"Incoming -- (30-05-2025) 5000 CFA",
      popup1Name:"",
      popup1:"",
      popup2Name:"",
      popup2:"",
    },
    
  ],
  additionalRead:[
    {
      title:"Watch Kevin Powell’s HTML Paragraph and Headings Video",
      url:"https://www.youtube.com/watch?v=yqcd-XkxZNM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=3"
    },
   
  ],
  KnowledgeCheck:[
    {
      check:"How do you create a paragraph in HTML?"
    },
    

  ],
  source:[
    {
      name:"TheodinProject",
      link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
    },
  ],
people:[]
},
    {
name:"Branding",
courseStatus:"Incomplete",

courseNumber:"005",
logo:logo2,
menu:[
{
  name:'Introduction',
  detail:"Whether it be IMDB’s top 250 movies or the FBI’s most wanted, lists are everywhere on the web and you are going to need one eventually in your webpages.",
  detail1:"Luckily, with HTML there are a couple of different types of lists at your disposal.",
  detail2:"",
  detail3:"",
  detail4:"",
  detail5:"",
  detail6:"",
  ancorName:"Introduction",
  popup1Name:"",
  popup1:"",
  popup2Name:"",
  popup2:"",
},

],
additionalRead:[
{
  title:"MDN documentation on the unordered list element",
  url:"https://developer.mozilla.org/en-US/docs/Web/HTML/Element/ul"
},

],
KnowledgeCheck:[
  {
    check:"What HTML tag is used to create an unordered list?"
  },
  
],
source:[
{
  name:"TheodinProject",
  link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
},
],
people:[]
},
{
  name:"Main Assets",
  courseStatus:"Incomplete",
  
  courseNumber:"005",
  logo:logo2,
  menu:[
  {
    name:'Introduction',
    detail:"Whether it be IMDB’s top 250 movies or the FBI’s most wanted, lists are everywhere on the web and you are going to need one eventually in your webpages.",
    detail1:"Luckily, with HTML there are a couple of different types of lists at your disposal.",
    detail2:"",
    detail3:"",
    detail4:"",
    detail5:"",
    detail6:"",
    ancorName:"Introduction",
    popup1Name:"",
    popup1:"",
    popup2Name:"",
    popup2:"",
  },
  
  ],
  additionalRead:[
  {
    title:"MDN documentation on the unordered list element",
    url:"https://developer.mozilla.org/en-US/docs/Web/HTML/Element/ul"
  },
  
  ],
  KnowledgeCheck:[
    {
      check:"What HTML tag is used to create an unordered list?"
    },
    
  ],
  source:[
  {
    name:"TheodinProject",
    link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
  },
  ],
  people:[],
  companyLevel2:[
    {
      name:"WoodWorks",
      courseStatus:"Incomplete",
      
      courseNumber:"006",
      logo:logo2,
      menu:[
      {
      name:'Introduction',
      detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
      detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
      detail2:"",
      detail3:"",
      detail4:"",
      detail5:"",
      detail6:"",
      ancorName:"Introduction",
      popup1Name:"",
      popup1:"",
      popup2Name:"",
      popup2:"",
      },
      
      ],
      additionalRead:[
      {
      title:"Watch Kevin Powell’s HTML Links Video.",
      url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
      },
      
      ],
      KnowledgeCheck:[
        {
          check:"What element is used to create a link?"
        },
        
      ],
      source:[
      {
      name:"TheodinProject",
      link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
      },
      {
      name:"download image ",
      link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
      },
      ],
      people:[],
    },
    {
      name:"embriodary",
      courseStatus:"Incomplete",
      
      courseNumber:"006",
      logo:logo2,
      menu:[
      {
      name:'Introduction',
      detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
      detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
      detail2:"",
      detail3:"",
      detail4:"",
      detail5:"",
      detail6:"",
      ancorName:"Introduction",
      popup1Name:"",
      popup1:"",
      popup2Name:"",
      popup2:"",
      },
      
      ],
      additionalRead:[
      {
      title:"Watch Kevin Powell’s HTML Links Video.",
      url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
      },
      
      ],
      KnowledgeCheck:[
        {
          check:"What element is used to create a link?"
        },
        
      ],
      source:[
      {
      name:"TheodinProject",
      link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
      },
      {
      name:"download image ",
      link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
      },
      ],
      people:[],
    },
    {
      name:"tialoring",
      courseStatus:"Incomplete",
      
      courseNumber:"006",
      logo:logo2,
      menu:[
      {
      name:'Introduction',
      detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
      detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
      detail2:"",
      detail3:"",
      detail4:"",
      detail5:"",
      detail6:"",
      ancorName:"Introduction",
      popup1Name:"",
      popup1:"",
      popup2Name:"",
      popup2:"",
      },
      
      ],
      additionalRead:[
      {
      title:"Watch Kevin Powell’s HTML Links Video.",
      url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
      },
      
      ],
      KnowledgeCheck:[
        {
          check:"What element is used to create a link?"
        },
        
      ],
      source:[
      {
      name:"TheodinProject",
      link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
      },
      {
      name:"download image ",
      link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
      },
      ],
      people:[],
    },
    {
      name:"leader works",
      courseStatus:"Incomplete",
      
      courseNumber:"006",
      logo:logo2,
      menu:[
      {
      name:'Introduction',
      detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
      detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
      detail2:"",
      detail3:"",
      detail4:"",
      detail5:"",
      detail6:"",
      ancorName:"Introduction",
      popup1Name:"",
      popup1:"",
      popup2Name:"",
      popup2:"",
      },
      
      ],
      additionalRead:[
      {
      title:"Watch Kevin Powell’s HTML Links Video.",
      url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
      },
      
      ],
      KnowledgeCheck:[
        {
          check:"What element is used to create a link?"
        },
        
      ],
      source:[
      {
      name:"TheodinProject",
      link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
      },
      {
      name:"download image ",
      link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
      },
      ],
      people:[],
    },
  ]
  },
  {
    name:"Main expense",
    courseStatus:"Incomplete",
    
    courseNumber:"005",
    logo:logo2,
    menu:[
    {
      name:'Introduction',
      detail:"Whether it be IMDB’s top 250 movies or the FBI’s most wanted, lists are everywhere on the web and you are going to need one eventually in your webpages.",
      detail1:"Luckily, with HTML there are a couple of different types of lists at your disposal.",
      detail2:"",
      detail3:"",
      detail4:"",
      detail5:"",
      detail6:"",
      ancorName:"Introduction",
      popup1Name:"",
      popup1:"",
      popup2Name:"",
      popup2:"",
    },
    
    ],
    additionalRead:[
    {
      title:"MDN documentation on the unordered list element",
      url:"https://developer.mozilla.org/en-US/docs/Web/HTML/Element/ul"
    },
    
    ],
    KnowledgeCheck:[
      {
        check:"What HTML tag is used to create an unordered list?"
      },
      
    ],
    source:[
    {
      name:"TheodinProject",
      link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
    },
    ],
    people:[]
    },
    {
name:"Marketing & money In",
courseStatus:"Incomplete",

courseNumber:"006",
logo:logo2,
menu:[
{
name:'Introduction',
detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
detail2:"",
detail3:"",
detail4:"",
detail5:"",
detail6:"",
ancorName:"Introduction",
popup1Name:"",
popup1:"",
popup2Name:"",
popup2:"",
},

],
additionalRead:[
{
title:"Watch Kevin Powell’s HTML Links Video.",
url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
},

],
KnowledgeCheck:[
  {
    check:"What element is used to create a link?"
  },
  
],
source:[
{
name:"TheodinProject",
link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
},
{
name:"download image ",
link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
},
],
people:[],
companyLevel2:[
  {
    name:"suberCraftex marketing",
    courseStatus:"Incomplete",
    
    courseNumber:"006",
    logo:logo2,
    menu:[
    {
    name:'Introduction',
    detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
    detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
    detail2:"",
    detail3:"",
    detail4:"",
    detail5:"",
    detail6:"",
    ancorName:"Introduction",
    popup1Name:"",
    popup1:"",
    popup2Name:"",
    popup2:"",
    },
    
    ],
    additionalRead:[
    {
    title:"Watch Kevin Powell’s HTML Links Video.",
    url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
    },
    
    ],
    KnowledgeCheck:[
      {
        check:"What element is used to create a link?"
      },
      
    ],
    source:[
    {
    name:"TheodinProject",
    link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
    },
    {
    name:"download image ",
    link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
    },
    ],
    people:[],
  },
  {
    name:"camsol Technologies marketing",
    courseStatus:"Incomplete",
    
    courseNumber:"006",
    logo:logo2,
    menu:[
    {
    name:'Introduction',
    detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
    detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
    detail2:"",
    detail3:"",
    detail4:"",
    detail5:"",
    detail6:"",
    ancorName:"Introduction",
    popup1Name:"",
    popup1:"",
    popup2Name:"",
    popup2:"",
    },
    {
    name:'Lesson Overview',
    detail:"This section contains a general overview of topics that you will learn in this lesson.",
    detail1:"1.)How to create links to pages on other websites on the internet",
    detail2:"2.)How to create links to other pages on your own websites",
    detail3:"3.)The difference between absolute and relative links",
    detail4:"4.)How to display an image on webpage using HTML",
    detail5:"",
    detail6:"",
    ancorName:"Lesson Overview",
    popup1Name:"",
    popup1:"",
    popup2Name:"",
    popup2:"",
    },
    {
    name:'Preparation',
    detail:"To get some practice using links and images throughout this lesson we need an HTML project to work with.",
    detail1:"1. Create a new directory named ```msb-links-and-images```.",
    detail2:"2. Within that directory, create a new file named index.html.",
    detail3:"3. Fill in the usual HTML boilerplate.",
    detail4:"4. Finally, add the following h1 to the body:",
    detail5:" <h1>Homepage</h1>",
    detail6:"",
    ancorName:"Preparation",
    popup1Name:"",
    popup1:"",
    popup2Name:"",
    popup2:"",
    },
    {
    name:'Anchor Elements',
    detail:"To create a link in HTML, we use the anchor element. An anchor element is defined by wrapping the text or another HTML element we want to be a link with an <a> tag.",
    detail1:"Add the following to the body of the index.html page we created and open it in the browser:",
    detail2:"<a>click me</a>",
    detail3:"You may have noticed that clicking this link doesn’t do anything. This is because an anchor tag on its own won’t know where we want to link to. We have to tell it a destination to go to. We do this by using an HTML attribute.",
    detail4:"An HTML attribute gives additional information to an HTML element and always goes in the element’s opening tag. An attribute is made up of two parts, a name, and a value. In our case, we need to add a href (hyperlink reference) attribute to the opening anchor tag. The value of the href attribute is the destination we want our link to go to.",
    detail5:"Add the following href attribute to the anchor element we created previously and try clicking it again, don’t forget to refresh the browser so the new changes can be applied.",
    detail6:'<a href="https://www.theodinproject.com/about">click me</a>',
    detail7:'By default, any text wrapped with an anchor tag without a href attribute will look like plain text. If the href attribute is present, the browser will give the text a blue color and underline it to signify it is a link.',
    detail8:'It’s worth noting you can use anchor tags to link to any kind of resource on the internet, not just other HTML documents. You can link to videos, pdf files, images, and so on, but for the most part, you will be linking to other HTML documents.',
    ancorName:"",
    popup1Name:"Anchor Elements",
    popup1:"",
    popup2Name:"",
    popup2:"",
    },
    {
    name:'Absolute and Relative Links',
    detail:"Generally, there are two kinds of links we will create:",
    detail1:"1. Links to pages on other websites on the internet",
    detail2:"2. Links to pages located on our own websites",
    detail3:"",
    detail4:"",
    detail5:"",
    detail6:"",
    ancorName:"Absolute and Relative Links",
    popup1Name:"",
    popup1:"",
    popup2Name:"",
    popup2:"",
    },
    {
    name:'Absolute Links',
    detail:"Links to pages on other websites on the internet are called absolute links. A typical absolute link will be made up of the following parts: protocol://domain/path. An absolute link will always contain the protocol and domain of the destination.",
    detail1:"We’ve already seen an absolute link in action. The link we created to The Odin Project’s About page earlier was an absolute link as it contains the protocol and domain.",
    detail2:"https://www.project.com/about",
    detail3:"",
    detail4:"",
    detail5:"",
    detail6:"",
    ancorName:"Absolute Links",
    popup1Name:"",
    popup1:"",
    popup2Name:"",
    popup2:"",
    },
    {
    name:'Relative Links',
    detail:"Links to other pages within our own website are called relative links. Relative links do not include the domain name, since it is another page on the same site, it assumes the domain name will be the same as the page we created the link on.",
    detail1:"Relative links only include the file path to the other page, relative to the page you are creating the link on. This is quite abstract, let’s see this in action using an example.",
    detail2:"Within ```the msb-links-and-images``` directory, create another HTML file named about.html and paste the following code into it:",
    detail3:"Back in the index page, add the following anchor element to create a link to the about page:",
    detail4:"Open the index file in a browser and click on the about link to make sure it is all wired together correctly. Clicking the link should go to the about page we just created.",
    detail5:"This works because the index and about page are in the same directory. That means we can simply use its name (about.html) as the link’s href value.",
    detail6:"But we will usually want to organize our website directories a little better. Normally we would only have the index.html at the root directory and all other HTML files in their own directory.",
    detail7:"Create a directory named pages within the odin-links-and-images directory and move the about.html file into this new directory.",
    detail8:"Refresh the index page in the browser and then click on the about link. It will now be broken. This is because the location of the about page file has changed.",
    detail9:"To fix this, we just need to update the about link href value to include the pages/ directory since that is the new location of the about file relative to the index file.",
    detail10:"Refresh the index page in the browser and try clicking the about link again, it should now be back in working order.",
    detail11:"In many cases, this will work just fine; however, you can still run into unexpected issues with this approach. Prepending ./ before the link will in most cases prevent such issues. By adding ./ you are specifying to your code that it should start looking for the file/directory relative to the current directory.",
    ancorName:"Relative Links",
    popup1Name:"relative link",
    popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653643895/msbGeanologyProfilePics/relative_link_td1h2t.png",
    popup2Name:"absolute link",
    popup2:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644249/msbGeanologyProfilePics/absolutlink_vmo5o6.png",
    },
    {
    name:'A Metaphor',
    detail:"Absolute and relative links are a tricky concept to build a good mental model of, a metaphor may help:",
    detail1:"Think of your domain name (town.com) as a town, the directory in which your website is located (/museum) as a museum, and each page on your website as a room in the museum (/museum/movie_room.html and /museum/shops/coffee_shop.html). Relative links like ./shops/coffee_shop.html are directions from the current room (the museum movie room /museum/movie_room.html) to another room (the museum shop). Absolute links, on the other hand, are full directions including the protocol (https), domain name (town.com) and the path from that domain name (/museum/shops/coffee_shop.html): https://town.com/museum/shops/coffee_shop.html.",
    detail2:"",
    detail3:"",
    detail4:"",
    detail5:"",
    detail6:"",
    ancorName:"A Metaphor",
    popup1Name:"",
    popup1:"",
    popup2Name:"",
    popup2:"",
    },
    {
    name:'Images',
    detail:"Websites would be fairly boring if they could only display text. Luckily HTML provides a wide variety of elements for displaying all sorts of different media. The most widely used of these is the image element.",
    detail1:"To display an image in HTML we use the <img> element. Unlike the other elements we have encountered so far, the <img> element is empty. Which means it doesn’t have a closing tag.",
    detail2:"Instead of wrapping content with an opening and closing tag, it embeds an image into the page using a src attribute which tells the browser where the image file is located. The src attribute works much like the href attribute for anchor tags. It can embed an image using both absolute and relative paths.",
    detail3:"For example, using an absolute path we can display an image located on The Odin Project site:",
    detail4:"To use images that we have on our own websites, we can use a relative path.",
    detail5:"1. Create a new directory named images within the odin-links-and-images project.",
    detail6:"2. Next, download this image and move it into the images directory we just created.(check the link to download in the source)",
    detail7:"3. Rename the image to dog.jpg.",
    detail8:"Finally add the image to the index.html file:",
    detail9:"Save the index.html file and open it in a browser to view Charles in all his glory.",
    ancorName:"Images",
    popup1Name:"image display",
    popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644641/msbGeanologyProfilePics/images_aqfnin.png",
    popup2Name:"",
    popup2:"",
    },
    {
    name:'Parent Directories',
    detail:"What if we want to use the dog image in the about page? We would first have to go up one level out of the pages directory into its parent directory so we could then access the images directory.",
    detail1:"To go to the parent directory we need to use two dots in the relative filepath like this: ../. Let’s see this in action, within the body of the about.html file, add the following image below the heading we added earlier:",
    detail2:'<img src="../images/dog.jpg">',
    detail3:"To break this down:",
    detail4:"1. First, we are going to the parent directory of the pages directory which is odin-links-and-images.",
    detail5:"2. Then, from the parent directory, we can go into the images directory.",
    detail6:"3. Finally, we can access the dog.jpg file.",
    detail7:"Using the metaphor we used earlier, using ../ in a filepath is kind of like stepping out from the room you are currently in to the main hallway so you can go to another room.",
    ancorName:"Parent Directories",
    popup1Name:"",
    popup1:"",
    popup2Name:"",
    popup2:"",
    },
    {
    name:'Alt attribute',
    detail:"Besides the src attribute, every image element should also have an alt (alternative text) attribute.",
    detail1:"The alt attribute is used to describe an image. It will be used in place of the image if it cannot be loaded. It is also used with screen readers to describe what the image is to visually impaired users.",
    detail2:"This is how the The Odin Project logo example we used earlier looks with an alt attribute included:",
    detail3:"As a bit of practice, add an alt attribute to the dog image we added to the odin-links-and-images project.",
    detail4:"",
    detail5:"",
    detail6:"",
    ancorName:"Alt attribute",
    popup1Name:"alt atribute",
    popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653646504/msbGeanologyProfilePics/image_atribute_ujkhst.png",
    popup2Name:"",
    popup2:"",
    },
    
    {
    name:'Assignment',
    detail:"Watch Kevin Powell’s HTML Links Video.",
    detail1:"Watch Kevin Powell’s HTML Images Video.",
    detail2:"Watch Kevin Powell’s File Structure Video.",
    detail3:"Read about the four main image formats that can be used on the web.",
    detail4:" ",
    detail5:"",
    detail6:"",
    ancorName:"Assignment",
    popup1Name:"",
    popup1:"",
    popup2Name:"",
    popup2:"",
    },
    
    {
    name:'',
    detail:"",
    detail1:"",
    detail2:"",
    detail3:"",
    detail4:"",
    detail5:"",
    detail6:"",
    ancorName:"",
    popup1Name:"",
    popup1:"",
    popup2Name:"",
    popup2:"",
    },
    ],
    additionalRead:[
    {
    title:"Watch Kevin Powell’s HTML Links Video.",
    url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
    },
    {
    title:"Watch Kevin Powell’s HTML Images Video",
    url:"https://www.youtube.com/watch?v=0xoztJCHpbQ&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=6"
    },
    {
    title:"Watch Kevin Powell’s File Structure Video.",
    url:"https://www.youtube.com/watch?v=ta3Oxx7Yqbo&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=7"
    },
    {
    title:"Read about the four main image formats that can be used on the web.",
    url:"https://www.internetingishard.com/html-and-css/links-and-images/#image-formats"
    },
    {
    title:"Interneting is hard’s treatment on HTML links and images",
    url:"https://www.internetingishard.com/html-and-css/links-and-images/"
    },
    {
    title:"What happened the day Google decided links including (/) were malware",
    url:"https://www.itpro.co.uk/609724/google-apologises-after-blacklisting-entire-internet"
    },
    ],
    KnowledgeCheck:[
      {
        check:"What element is used to create a link?"
      },
      {
        check:"What is an attribute?"
      },
      {
        check:"What attribute tells links where to go to?"
      },
      {
        check:"What is the difference between an absolute and relative link?"
      },
    
      {
        check:"Which element is used to display an image?"
      },
      {
        check:"What two attributes do images always need to have?"
      },
      {
        check:"How do you access a parent directory in a filepath?"
      },
      {
        check:"What are the four main image formats that you can use for images on the web?"
      },
    ],
    source:[
    {
    name:"TheodinProject",
    link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
    },
    {
    name:"download image ",
    link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
    },
    ],
    people:[],

    companyLevel3:[
      {
        name:"e-marketing",
        courseStatus:"Incomplete",
        
        courseNumber:"006",
        logo:logo2,
        menu:[
        {
        name:'Introduction',
        detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
        detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        ancorName:"Introduction",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
        },
        {
        name:'Lesson Overview',
        detail:"This section contains a general overview of topics that you will learn in this lesson.",
        detail1:"1.)How to create links to pages on other websites on the internet",
        detail2:"2.)How to create links to other pages on your own websites",
        detail3:"3.)The difference between absolute and relative links",
        detail4:"4.)How to display an image on webpage using HTML",
        detail5:"",
        detail6:"",
        ancorName:"Lesson Overview",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
        },
        {
        name:'Preparation',
        detail:"To get some practice using links and images throughout this lesson we need an HTML project to work with.",
        detail1:"1. Create a new directory named ```msb-links-and-images```.",
        detail2:"2. Within that directory, create a new file named index.html.",
        detail3:"3. Fill in the usual HTML boilerplate.",
        detail4:"4. Finally, add the following h1 to the body:",
        detail5:" <h1>Homepage</h1>",
        detail6:"",
        ancorName:"Preparation",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
        },
        {
        name:'Anchor Elements',
        detail:"To create a link in HTML, we use the anchor element. An anchor element is defined by wrapping the text or another HTML element we want to be a link with an <a> tag.",
        detail1:"Add the following to the body of the index.html page we created and open it in the browser:",
        detail2:"<a>click me</a>",
        detail3:"You may have noticed that clicking this link doesn’t do anything. This is because an anchor tag on its own won’t know where we want to link to. We have to tell it a destination to go to. We do this by using an HTML attribute.",
        detail4:"An HTML attribute gives additional information to an HTML element and always goes in the element’s opening tag. An attribute is made up of two parts, a name, and a value. In our case, we need to add a href (hyperlink reference) attribute to the opening anchor tag. The value of the href attribute is the destination we want our link to go to.",
        detail5:"Add the following href attribute to the anchor element we created previously and try clicking it again, don’t forget to refresh the browser so the new changes can be applied.",
        detail6:'<a href="https://www.theodinproject.com/about">click me</a>',
        detail7:'By default, any text wrapped with an anchor tag without a href attribute will look like plain text. If the href attribute is present, the browser will give the text a blue color and underline it to signify it is a link.',
        detail8:'It’s worth noting you can use anchor tags to link to any kind of resource on the internet, not just other HTML documents. You can link to videos, pdf files, images, and so on, but for the most part, you will be linking to other HTML documents.',
        ancorName:"",
        popup1Name:"Anchor Elements",
        popup1:"",
        popup2Name:"",
        popup2:"",
        },
        {
        name:'Absolute and Relative Links',
        detail:"Generally, there are two kinds of links we will create:",
        detail1:"1. Links to pages on other websites on the internet",
        detail2:"2. Links to pages located on our own websites",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        ancorName:"Absolute and Relative Links",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
        },
        {
        name:'Absolute Links',
        detail:"Links to pages on other websites on the internet are called absolute links. A typical absolute link will be made up of the following parts: protocol://domain/path. An absolute link will always contain the protocol and domain of the destination.",
        detail1:"We’ve already seen an absolute link in action. The link we created to The Odin Project’s About page earlier was an absolute link as it contains the protocol and domain.",
        detail2:"https://www.project.com/about",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        ancorName:"Absolute Links",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
        },
        {
        name:'Relative Links',
        detail:"Links to other pages within our own website are called relative links. Relative links do not include the domain name, since it is another page on the same site, it assumes the domain name will be the same as the page we created the link on.",
        detail1:"Relative links only include the file path to the other page, relative to the page you are creating the link on. This is quite abstract, let’s see this in action using an example.",
        detail2:"Within ```the msb-links-and-images``` directory, create another HTML file named about.html and paste the following code into it:",
        detail3:"Back in the index page, add the following anchor element to create a link to the about page:",
        detail4:"Open the index file in a browser and click on the about link to make sure it is all wired together correctly. Clicking the link should go to the about page we just created.",
        detail5:"This works because the index and about page are in the same directory. That means we can simply use its name (about.html) as the link’s href value.",
        detail6:"But we will usually want to organize our website directories a little better. Normally we would only have the index.html at the root directory and all other HTML files in their own directory.",
        detail7:"Create a directory named pages within the odin-links-and-images directory and move the about.html file into this new directory.",
        detail8:"Refresh the index page in the browser and then click on the about link. It will now be broken. This is because the location of the about page file has changed.",
        detail9:"To fix this, we just need to update the about link href value to include the pages/ directory since that is the new location of the about file relative to the index file.",
        detail10:"Refresh the index page in the browser and try clicking the about link again, it should now be back in working order.",
        detail11:"In many cases, this will work just fine; however, you can still run into unexpected issues with this approach. Prepending ./ before the link will in most cases prevent such issues. By adding ./ you are specifying to your code that it should start looking for the file/directory relative to the current directory.",
        ancorName:"Relative Links",
        popup1Name:"relative link",
        popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653643895/msbGeanologyProfilePics/relative_link_td1h2t.png",
        popup2Name:"absolute link",
        popup2:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644249/msbGeanologyProfilePics/absolutlink_vmo5o6.png",
        },
        {
        name:'A Metaphor',
        detail:"Absolute and relative links are a tricky concept to build a good mental model of, a metaphor may help:",
        detail1:"Think of your domain name (town.com) as a town, the directory in which your website is located (/museum) as a museum, and each page on your website as a room in the museum (/museum/movie_room.html and /museum/shops/coffee_shop.html). Relative links like ./shops/coffee_shop.html are directions from the current room (the museum movie room /museum/movie_room.html) to another room (the museum shop). Absolute links, on the other hand, are full directions including the protocol (https), domain name (town.com) and the path from that domain name (/museum/shops/coffee_shop.html): https://town.com/museum/shops/coffee_shop.html.",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        ancorName:"A Metaphor",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
        },
        {
        name:'Images',
        detail:"Websites would be fairly boring if they could only display text. Luckily HTML provides a wide variety of elements for displaying all sorts of different media. The most widely used of these is the image element.",
        detail1:"To display an image in HTML we use the <img> element. Unlike the other elements we have encountered so far, the <img> element is empty. Which means it doesn’t have a closing tag.",
        detail2:"Instead of wrapping content with an opening and closing tag, it embeds an image into the page using a src attribute which tells the browser where the image file is located. The src attribute works much like the href attribute for anchor tags. It can embed an image using both absolute and relative paths.",
        detail3:"For example, using an absolute path we can display an image located on The Odin Project site:",
        detail4:"To use images that we have on our own websites, we can use a relative path.",
        detail5:"1. Create a new directory named images within the odin-links-and-images project.",
        detail6:"2. Next, download this image and move it into the images directory we just created.(check the link to download in the source)",
        detail7:"3. Rename the image to dog.jpg.",
        detail8:"Finally add the image to the index.html file:",
        detail9:"Save the index.html file and open it in a browser to view Charles in all his glory.",
        ancorName:"Images",
        popup1Name:"image display",
        popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644641/msbGeanologyProfilePics/images_aqfnin.png",
        popup2Name:"",
        popup2:"",
        },
        {
        name:'Parent Directories',
        detail:"What if we want to use the dog image in the about page? We would first have to go up one level out of the pages directory into its parent directory so we could then access the images directory.",
        detail1:"To go to the parent directory we need to use two dots in the relative filepath like this: ../. Let’s see this in action, within the body of the about.html file, add the following image below the heading we added earlier:",
        detail2:'<img src="../images/dog.jpg">',
        detail3:"To break this down:",
        detail4:"1. First, we are going to the parent directory of the pages directory which is odin-links-and-images.",
        detail5:"2. Then, from the parent directory, we can go into the images directory.",
        detail6:"3. Finally, we can access the dog.jpg file.",
        detail7:"Using the metaphor we used earlier, using ../ in a filepath is kind of like stepping out from the room you are currently in to the main hallway so you can go to another room.",
        ancorName:"Parent Directories",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
        },
        {
        name:'Alt attribute',
        detail:"Besides the src attribute, every image element should also have an alt (alternative text) attribute.",
        detail1:"The alt attribute is used to describe an image. It will be used in place of the image if it cannot be loaded. It is also used with screen readers to describe what the image is to visually impaired users.",
        detail2:"This is how the The Odin Project logo example we used earlier looks with an alt attribute included:",
        detail3:"As a bit of practice, add an alt attribute to the dog image we added to the odin-links-and-images project.",
        detail4:"",
        detail5:"",
        detail6:"",
        ancorName:"Alt attribute",
        popup1Name:"alt atribute",
        popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653646504/msbGeanologyProfilePics/image_atribute_ujkhst.png",
        popup2Name:"",
        popup2:"",
        },
        
        {
        name:'Assignment',
        detail:"Watch Kevin Powell’s HTML Links Video.",
        detail1:"Watch Kevin Powell’s HTML Images Video.",
        detail2:"Watch Kevin Powell’s File Structure Video.",
        detail3:"Read about the four main image formats that can be used on the web.",
        detail4:" ",
        detail5:"",
        detail6:"",
        ancorName:"Assignment",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
        },
        
        {
        name:'',
        detail:"",
        detail1:"",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        ancorName:"",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
        },
        ],
        additionalRead:[
        {
        title:"Watch Kevin Powell’s HTML Links Video.",
        url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
        },
        {
        title:"Watch Kevin Powell’s HTML Images Video",
        url:"https://www.youtube.com/watch?v=0xoztJCHpbQ&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=6"
        },
        {
        title:"Watch Kevin Powell’s File Structure Video.",
        url:"https://www.youtube.com/watch?v=ta3Oxx7Yqbo&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=7"
        },
        {
        title:"Read about the four main image formats that can be used on the web.",
        url:"https://www.internetingishard.com/html-and-css/links-and-images/#image-formats"
        },
        {
        title:"Interneting is hard’s treatment on HTML links and images",
        url:"https://www.internetingishard.com/html-and-css/links-and-images/"
        },
        {
        title:"What happened the day Google decided links including (/) were malware",
        url:"https://www.itpro.co.uk/609724/google-apologises-after-blacklisting-entire-internet"
        },
        ],
        KnowledgeCheck:[
          {
            check:"What element is used to create a link?"
          },
          {
            check:"What is an attribute?"
          },
          {
            check:"What attribute tells links where to go to?"
          },
          {
            check:"What is the difference between an absolute and relative link?"
          },
        
          {
            check:"Which element is used to display an image?"
          },
          {
            check:"What two attributes do images always need to have?"
          },
          {
            check:"How do you access a parent directory in a filepath?"
          },
          {
            check:"What are the four main image formats that you can use for images on the web?"
          },
        ],
        source:[
        {
        name:"TheodinProject",
        link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
        },
        {
        name:"download image ",
        link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
        },
        ],
        people:[],
        companyLevel4:[
          {
            name:"Online Investors/clients",
            courseStatus:"Incomplete",
            
            courseNumber:"006",
            logo:logo2,
            menu:[
            {
            name:'Introduction',
            detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
            detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Introduction",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Lesson Overview',
            detail:"This section contains a general overview of topics that you will learn in this lesson.",
            detail1:"1.)How to create links to pages on other websites on the internet",
            detail2:"2.)How to create links to other pages on your own websites",
            detail3:"3.)The difference between absolute and relative links",
            detail4:"4.)How to display an image on webpage using HTML",
            detail5:"",
            detail6:"",
            ancorName:"Lesson Overview",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Preparation',
            detail:"To get some practice using links and images throughout this lesson we need an HTML project to work with.",
            detail1:"1. Create a new directory named ```msb-links-and-images```.",
            detail2:"2. Within that directory, create a new file named index.html.",
            detail3:"3. Fill in the usual HTML boilerplate.",
            detail4:"4. Finally, add the following h1 to the body:",
            detail5:" <h1>Homepage</h1>",
            detail6:"",
            ancorName:"Preparation",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Anchor Elements',
            detail:"To create a link in HTML, we use the anchor element. An anchor element is defined by wrapping the text or another HTML element we want to be a link with an <a> tag.",
            detail1:"Add the following to the body of the index.html page we created and open it in the browser:",
            detail2:"<a>click me</a>",
            detail3:"You may have noticed that clicking this link doesn’t do anything. This is because an anchor tag on its own won’t know where we want to link to. We have to tell it a destination to go to. We do this by using an HTML attribute.",
            detail4:"An HTML attribute gives additional information to an HTML element and always goes in the element’s opening tag. An attribute is made up of two parts, a name, and a value. In our case, we need to add a href (hyperlink reference) attribute to the opening anchor tag. The value of the href attribute is the destination we want our link to go to.",
            detail5:"Add the following href attribute to the anchor element we created previously and try clicking it again, don’t forget to refresh the browser so the new changes can be applied.",
            detail6:'<a href="https://www.theodinproject.com/about">click me</a>',
            detail7:'By default, any text wrapped with an anchor tag without a href attribute will look like plain text. If the href attribute is present, the browser will give the text a blue color and underline it to signify it is a link.',
            detail8:'It’s worth noting you can use anchor tags to link to any kind of resource on the internet, not just other HTML documents. You can link to videos, pdf files, images, and so on, but for the most part, you will be linking to other HTML documents.',
            ancorName:"",
            popup1Name:"Anchor Elements",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Absolute and Relative Links',
            detail:"Generally, there are two kinds of links we will create:",
            detail1:"1. Links to pages on other websites on the internet",
            detail2:"2. Links to pages located on our own websites",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Absolute and Relative Links",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Absolute Links',
            detail:"Links to pages on other websites on the internet are called absolute links. A typical absolute link will be made up of the following parts: protocol://domain/path. An absolute link will always contain the protocol and domain of the destination.",
            detail1:"We’ve already seen an absolute link in action. The link we created to The Odin Project’s About page earlier was an absolute link as it contains the protocol and domain.",
            detail2:"https://www.project.com/about",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Absolute Links",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Relative Links',
            detail:"Links to other pages within our own website are called relative links. Relative links do not include the domain name, since it is another page on the same site, it assumes the domain name will be the same as the page we created the link on.",
            detail1:"Relative links only include the file path to the other page, relative to the page you are creating the link on. This is quite abstract, let’s see this in action using an example.",
            detail2:"Within ```the msb-links-and-images``` directory, create another HTML file named about.html and paste the following code into it:",
            detail3:"Back in the index page, add the following anchor element to create a link to the about page:",
            detail4:"Open the index file in a browser and click on the about link to make sure it is all wired together correctly. Clicking the link should go to the about page we just created.",
            detail5:"This works because the index and about page are in the same directory. That means we can simply use its name (about.html) as the link’s href value.",
            detail6:"But we will usually want to organize our website directories a little better. Normally we would only have the index.html at the root directory and all other HTML files in their own directory.",
            detail7:"Create a directory named pages within the odin-links-and-images directory and move the about.html file into this new directory.",
            detail8:"Refresh the index page in the browser and then click on the about link. It will now be broken. This is because the location of the about page file has changed.",
            detail9:"To fix this, we just need to update the about link href value to include the pages/ directory since that is the new location of the about file relative to the index file.",
            detail10:"Refresh the index page in the browser and try clicking the about link again, it should now be back in working order.",
            detail11:"In many cases, this will work just fine; however, you can still run into unexpected issues with this approach. Prepending ./ before the link will in most cases prevent such issues. By adding ./ you are specifying to your code that it should start looking for the file/directory relative to the current directory.",
            ancorName:"Relative Links",
            popup1Name:"relative link",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653643895/msbGeanologyProfilePics/relative_link_td1h2t.png",
            popup2Name:"absolute link",
            popup2:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644249/msbGeanologyProfilePics/absolutlink_vmo5o6.png",
            },
            {
            name:'A Metaphor',
            detail:"Absolute and relative links are a tricky concept to build a good mental model of, a metaphor may help:",
            detail1:"Think of your domain name (town.com) as a town, the directory in which your website is located (/museum) as a museum, and each page on your website as a room in the museum (/museum/movie_room.html and /museum/shops/coffee_shop.html). Relative links like ./shops/coffee_shop.html are directions from the current room (the museum movie room /museum/movie_room.html) to another room (the museum shop). Absolute links, on the other hand, are full directions including the protocol (https), domain name (town.com) and the path from that domain name (/museum/shops/coffee_shop.html): https://town.com/museum/shops/coffee_shop.html.",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"A Metaphor",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Images',
            detail:"Websites would be fairly boring if they could only display text. Luckily HTML provides a wide variety of elements for displaying all sorts of different media. The most widely used of these is the image element.",
            detail1:"To display an image in HTML we use the <img> element. Unlike the other elements we have encountered so far, the <img> element is empty. Which means it doesn’t have a closing tag.",
            detail2:"Instead of wrapping content with an opening and closing tag, it embeds an image into the page using a src attribute which tells the browser where the image file is located. The src attribute works much like the href attribute for anchor tags. It can embed an image using both absolute and relative paths.",
            detail3:"For example, using an absolute path we can display an image located on The Odin Project site:",
            detail4:"To use images that we have on our own websites, we can use a relative path.",
            detail5:"1. Create a new directory named images within the odin-links-and-images project.",
            detail6:"2. Next, download this image and move it into the images directory we just created.(check the link to download in the source)",
            detail7:"3. Rename the image to dog.jpg.",
            detail8:"Finally add the image to the index.html file:",
            detail9:"Save the index.html file and open it in a browser to view Charles in all his glory.",
            ancorName:"Images",
            popup1Name:"image display",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644641/msbGeanologyProfilePics/images_aqfnin.png",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Parent Directories',
            detail:"What if we want to use the dog image in the about page? We would first have to go up one level out of the pages directory into its parent directory so we could then access the images directory.",
            detail1:"To go to the parent directory we need to use two dots in the relative filepath like this: ../. Let’s see this in action, within the body of the about.html file, add the following image below the heading we added earlier:",
            detail2:'<img src="../images/dog.jpg">',
            detail3:"To break this down:",
            detail4:"1. First, we are going to the parent directory of the pages directory which is odin-links-and-images.",
            detail5:"2. Then, from the parent directory, we can go into the images directory.",
            detail6:"3. Finally, we can access the dog.jpg file.",
            detail7:"Using the metaphor we used earlier, using ../ in a filepath is kind of like stepping out from the room you are currently in to the main hallway so you can go to another room.",
            ancorName:"Parent Directories",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Alt attribute',
            detail:"Besides the src attribute, every image element should also have an alt (alternative text) attribute.",
            detail1:"The alt attribute is used to describe an image. It will be used in place of the image if it cannot be loaded. It is also used with screen readers to describe what the image is to visually impaired users.",
            detail2:"This is how the The Odin Project logo example we used earlier looks with an alt attribute included:",
            detail3:"As a bit of practice, add an alt attribute to the dog image we added to the odin-links-and-images project.",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Alt attribute",
            popup1Name:"alt atribute",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653646504/msbGeanologyProfilePics/image_atribute_ujkhst.png",
            popup2Name:"",
            popup2:"",
            },
            
            {
            name:'Assignment',
            detail:"Watch Kevin Powell’s HTML Links Video.",
            detail1:"Watch Kevin Powell’s HTML Images Video.",
            detail2:"Watch Kevin Powell’s File Structure Video.",
            detail3:"Read about the four main image formats that can be used on the web.",
            detail4:" ",
            detail5:"",
            detail6:"",
            ancorName:"Assignment",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            
            {
            name:'',
            detail:"",
            detail1:"",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            ],
            additionalRead:[
            {
            title:"Watch Kevin Powell’s HTML Links Video.",
            url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
            },
            {
            title:"Watch Kevin Powell’s HTML Images Video",
            url:"https://www.youtube.com/watch?v=0xoztJCHpbQ&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=6"
            },
            {
            title:"Watch Kevin Powell’s File Structure Video.",
            url:"https://www.youtube.com/watch?v=ta3Oxx7Yqbo&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=7"
            },
            {
            title:"Read about the four main image formats that can be used on the web.",
            url:"https://www.internetingishard.com/html-and-css/links-and-images/#image-formats"
            },
            {
            title:"Interneting is hard’s treatment on HTML links and images",
            url:"https://www.internetingishard.com/html-and-css/links-and-images/"
            },
            {
            title:"What happened the day Google decided links including (/) were malware",
            url:"https://www.itpro.co.uk/609724/google-apologises-after-blacklisting-entire-internet"
            },
            ],
            KnowledgeCheck:[
              {
                check:"What element is used to create a link?"
              },
              {
                check:"What is an attribute?"
              },
              {
                check:"What attribute tells links where to go to?"
              },
              {
                check:"What is the difference between an absolute and relative link?"
              },
            
              {
                check:"Which element is used to display an image?"
              },
              {
                check:"What two attributes do images always need to have?"
              },
              {
                check:"How do you access a parent directory in a filepath?"
              },
              {
                check:"What are the four main image formats that you can use for images on the web?"
              },
            ],
            source:[
            {
            name:"TheodinProject",
            link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
            },
            {
            name:"download image ",
            link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
            },
            ],
            people:[],
            companyLevel5:[
              {
                name:"email",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Day-01(29-05-2025) valletPay Produndra reachout',
                detail:"PFD -Acumen- Apply to be a parther -> https://www.linkedin.com/company/acumen-fund/",
                detail1:"PFD -UNDP YouthConnekt Africa- YouthConnekt Africa collaborates with various partners, including the Tony Elumelu Foundation, to focus on youth entrepreneurship and empowerment in Africa.",
                detail2:"PFD ",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Day-01(29-05-2025) valletPay Produndra reachout",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Day-01(30-05-2025) valletPay Produndra reachout',
                detail:"reachout on my personal contacts( boris) and Martin, no results",
                detail1:"install and set up Odoo for the POS and all the other management",
                detail2:"went to go see Kome to show the work i have done, if he is okay",
                detail3:"3.)The difference between absolute and relative links",
                detail4:"4.)How to display an image on webpage using HTML",
                detail5:"",
                detail6:"",
                ancorName:"Day-01(30-05-2025) valletPay Produndra reachout",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Preparation',
                detail:"To get some practice using links and images throughout this lesson we need an HTML project to work with.",
                detail1:"1. Create a new directory named ```msb-links-and-images```.",
                detail2:"2. Within that directory, create a new file named index.html.",
                detail3:"3. Fill in the usual HTML boilerplate.",
                detail4:"4. Finally, add the following h1 to the body:",
                detail5:" <h1>Homepage</h1>",
                detail6:"",
                ancorName:"Preparation",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Anchor Elements',
                detail:"To create a link in HTML, we use the anchor element. An anchor element is defined by wrapping the text or another HTML element we want to be a link with an <a> tag.",
                detail1:"Add the following to the body of the index.html page we created and open it in the browser:",
                detail2:"<a>click me</a>",
                detail3:"You may have noticed that clicking this link doesn’t do anything. This is because an anchor tag on its own won’t know where we want to link to. We have to tell it a destination to go to. We do this by using an HTML attribute.",
                detail4:"An HTML attribute gives additional information to an HTML element and always goes in the element’s opening tag. An attribute is made up of two parts, a name, and a value. In our case, we need to add a href (hyperlink reference) attribute to the opening anchor tag. The value of the href attribute is the destination we want our link to go to.",
                detail5:"Add the following href attribute to the anchor element we created previously and try clicking it again, don’t forget to refresh the browser so the new changes can be applied.",
                detail6:'<a href="https://www.theodinproject.com/about">click me</a>',
                detail7:'By default, any text wrapped with an anchor tag without a href attribute will look like plain text. If the href attribute is present, the browser will give the text a blue color and underline it to signify it is a link.',
                detail8:'It’s worth noting you can use anchor tags to link to any kind of resource on the internet, not just other HTML documents. You can link to videos, pdf files, images, and so on, but for the most part, you will be linking to other HTML documents.',
                ancorName:"",
                popup1Name:"Anchor Elements",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Absolute and Relative Links',
                detail:"Generally, there are two kinds of links we will create:",
                detail1:"1. Links to pages on other websites on the internet",
                detail2:"2. Links to pages located on our own websites",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Absolute and Relative Links",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Absolute Links',
                detail:"Links to pages on other websites on the internet are called absolute links. A typical absolute link will be made up of the following parts: protocol://domain/path. An absolute link will always contain the protocol and domain of the destination.",
                detail1:"We’ve already seen an absolute link in action. The link we created to The Odin Project’s About page earlier was an absolute link as it contains the protocol and domain.",
                detail2:"https://www.project.com/about",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Absolute Links",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Relative Links',
                detail:"Links to other pages within our own website are called relative links. Relative links do not include the domain name, since it is another page on the same site, it assumes the domain name will be the same as the page we created the link on.",
                detail1:"Relative links only include the file path to the other page, relative to the page you are creating the link on. This is quite abstract, let’s see this in action using an example.",
                detail2:"Within ```the msb-links-and-images``` directory, create another HTML file named about.html and paste the following code into it:",
                detail3:"Back in the index page, add the following anchor element to create a link to the about page:",
                detail4:"Open the index file in a browser and click on the about link to make sure it is all wired together correctly. Clicking the link should go to the about page we just created.",
                detail5:"This works because the index and about page are in the same directory. That means we can simply use its name (about.html) as the link’s href value.",
                detail6:"But we will usually want to organize our website directories a little better. Normally we would only have the index.html at the root directory and all other HTML files in their own directory.",
                detail7:"Create a directory named pages within the odin-links-and-images directory and move the about.html file into this new directory.",
                detail8:"Refresh the index page in the browser and then click on the about link. It will now be broken. This is because the location of the about page file has changed.",
                detail9:"To fix this, we just need to update the about link href value to include the pages/ directory since that is the new location of the about file relative to the index file.",
                detail10:"Refresh the index page in the browser and try clicking the about link again, it should now be back in working order.",
                detail11:"In many cases, this will work just fine; however, you can still run into unexpected issues with this approach. Prepending ./ before the link will in most cases prevent such issues. By adding ./ you are specifying to your code that it should start looking for the file/directory relative to the current directory.",
                ancorName:"Relative Links",
                popup1Name:"relative link",
                popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653643895/msbGeanologyProfilePics/relative_link_td1h2t.png",
                popup2Name:"absolute link",
                popup2:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644249/msbGeanologyProfilePics/absolutlink_vmo5o6.png",
                },
                {
                name:'A Metaphor',
                detail:"Absolute and relative links are a tricky concept to build a good mental model of, a metaphor may help:",
                detail1:"Think of your domain name (town.com) as a town, the directory in which your website is located (/museum) as a museum, and each page on your website as a room in the museum (/museum/movie_room.html and /museum/shops/coffee_shop.html). Relative links like ./shops/coffee_shop.html are directions from the current room (the museum movie room /museum/movie_room.html) to another room (the museum shop). Absolute links, on the other hand, are full directions including the protocol (https), domain name (town.com) and the path from that domain name (/museum/shops/coffee_shop.html): https://town.com/museum/shops/coffee_shop.html.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"A Metaphor",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Images',
                detail:"Websites would be fairly boring if they could only display text. Luckily HTML provides a wide variety of elements for displaying all sorts of different media. The most widely used of these is the image element.",
                detail1:"To display an image in HTML we use the <img> element. Unlike the other elements we have encountered so far, the <img> element is empty. Which means it doesn’t have a closing tag.",
                detail2:"Instead of wrapping content with an opening and closing tag, it embeds an image into the page using a src attribute which tells the browser where the image file is located. The src attribute works much like the href attribute for anchor tags. It can embed an image using both absolute and relative paths.",
                detail3:"For example, using an absolute path we can display an image located on The Odin Project site:",
                detail4:"To use images that we have on our own websites, we can use a relative path.",
                detail5:"1. Create a new directory named images within the odin-links-and-images project.",
                detail6:"2. Next, download this image and move it into the images directory we just created.(check the link to download in the source)",
                detail7:"3. Rename the image to dog.jpg.",
                detail8:"Finally add the image to the index.html file:",
                detail9:"Save the index.html file and open it in a browser to view Charles in all his glory.",
                ancorName:"Images",
                popup1Name:"image display",
                popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644641/msbGeanologyProfilePics/images_aqfnin.png",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Parent Directories',
                detail:"What if we want to use the dog image in the about page? We would first have to go up one level out of the pages directory into its parent directory so we could then access the images directory.",
                detail1:"To go to the parent directory we need to use two dots in the relative filepath like this: ../. Let’s see this in action, within the body of the about.html file, add the following image below the heading we added earlier:",
                detail2:'<img src="../images/dog.jpg">',
                detail3:"To break this down:",
                detail4:"1. First, we are going to the parent directory of the pages directory which is odin-links-and-images.",
                detail5:"2. Then, from the parent directory, we can go into the images directory.",
                detail6:"3. Finally, we can access the dog.jpg file.",
                detail7:"Using the metaphor we used earlier, using ../ in a filepath is kind of like stepping out from the room you are currently in to the main hallway so you can go to another room.",
                ancorName:"Parent Directories",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Alt attribute',
                detail:"Besides the src attribute, every image element should also have an alt (alternative text) attribute.",
                detail1:"The alt attribute is used to describe an image. It will be used in place of the image if it cannot be loaded. It is also used with screen readers to describe what the image is to visually impaired users.",
                detail2:"This is how the The Odin Project logo example we used earlier looks with an alt attribute included:",
                detail3:"As a bit of practice, add an alt attribute to the dog image we added to the odin-links-and-images project.",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Alt attribute",
                popup1Name:"alt atribute",
                popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653646504/msbGeanologyProfilePics/image_atribute_ujkhst.png",
                popup2Name:"",
                popup2:"",
                },
                
                {
                name:'Assignment',
                detail:"Watch Kevin Powell’s HTML Links Video.",
                detail1:"Watch Kevin Powell’s HTML Images Video.",
                detail2:"Watch Kevin Powell’s File Structure Video.",
                detail3:"Read about the four main image formats that can be used on the web.",
                detail4:" ",
                detail5:"",
                detail6:"",
                ancorName:"Assignment",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                {
                name:'',
                detail:"",
                detail1:"",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                {
                title:"Watch Kevin Powell’s HTML Images Video",
                url:"https://www.youtube.com/watch?v=0xoztJCHpbQ&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=6"
                },
                {
                title:"Watch Kevin Powell’s File Structure Video.",
                url:"https://www.youtube.com/watch?v=ta3Oxx7Yqbo&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=7"
                },
                {
                title:"Read about the four main image formats that can be used on the web.",
                url:"https://www.internetingishard.com/html-and-css/links-and-images/#image-formats"
                },
                {
                title:"Interneting is hard’s treatment on HTML links and images",
                url:"https://www.internetingishard.com/html-and-css/links-and-images/"
                },
                {
                title:"What happened the day Google decided links including (/) were malware",
                url:"https://www.itpro.co.uk/609724/google-apologises-after-blacklisting-entire-internet"
                },
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  {
                    check:"What is an attribute?"
                  },
                  {
                    check:"What attribute tells links where to go to?"
                  },
                  {
                    check:"What is the difference between an absolute and relative link?"
                  },
                
                  {
                    check:"Which element is used to display an image?"
                  },
                  {
                    check:"What two attributes do images always need to have?"
                  },
                  {
                    check:"How do you access a parent directory in a filepath?"
                  },
                  {
                    check:"What are the four main image formats that you can use for images on the web?"
                  },
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[],
                
              },
              {
                name:"referals",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Lesson Overview',
                detail:"This section contains a general overview of topics that you will learn in this lesson.",
                detail1:"1.)How to create links to pages on other websites on the internet",
                detail2:"2.)How to create links to other pages on your own websites",
                detail3:"3.)The difference between absolute and relative links",
                detail4:"4.)How to display an image on webpage using HTML",
                detail5:"",
                detail6:"",
                ancorName:"Lesson Overview",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Preparation',
                detail:"To get some practice using links and images throughout this lesson we need an HTML project to work with.",
                detail1:"1. Create a new directory named ```msb-links-and-images```.",
                detail2:"2. Within that directory, create a new file named index.html.",
                detail3:"3. Fill in the usual HTML boilerplate.",
                detail4:"4. Finally, add the following h1 to the body:",
                detail5:" <h1>Homepage</h1>",
                detail6:"",
                ancorName:"Preparation",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Anchor Elements',
                detail:"To create a link in HTML, we use the anchor element. An anchor element is defined by wrapping the text or another HTML element we want to be a link with an <a> tag.",
                detail1:"Add the following to the body of the index.html page we created and open it in the browser:",
                detail2:"<a>click me</a>",
                detail3:"You may have noticed that clicking this link doesn’t do anything. This is because an anchor tag on its own won’t know where we want to link to. We have to tell it a destination to go to. We do this by using an HTML attribute.",
                detail4:"An HTML attribute gives additional information to an HTML element and always goes in the element’s opening tag. An attribute is made up of two parts, a name, and a value. In our case, we need to add a href (hyperlink reference) attribute to the opening anchor tag. The value of the href attribute is the destination we want our link to go to.",
                detail5:"Add the following href attribute to the anchor element we created previously and try clicking it again, don’t forget to refresh the browser so the new changes can be applied.",
                detail6:'<a href="https://www.theodinproject.com/about">click me</a>',
                detail7:'By default, any text wrapped with an anchor tag without a href attribute will look like plain text. If the href attribute is present, the browser will give the text a blue color and underline it to signify it is a link.',
                detail8:'It’s worth noting you can use anchor tags to link to any kind of resource on the internet, not just other HTML documents. You can link to videos, pdf files, images, and so on, but for the most part, you will be linking to other HTML documents.',
                ancorName:"",
                popup1Name:"Anchor Elements",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Absolute and Relative Links',
                detail:"Generally, there are two kinds of links we will create:",
                detail1:"1. Links to pages on other websites on the internet",
                detail2:"2. Links to pages located on our own websites",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Absolute and Relative Links",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Absolute Links',
                detail:"Links to pages on other websites on the internet are called absolute links. A typical absolute link will be made up of the following parts: protocol://domain/path. An absolute link will always contain the protocol and domain of the destination.",
                detail1:"We’ve already seen an absolute link in action. The link we created to The Odin Project’s About page earlier was an absolute link as it contains the protocol and domain.",
                detail2:"https://www.project.com/about",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Absolute Links",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Relative Links',
                detail:"Links to other pages within our own website are called relative links. Relative links do not include the domain name, since it is another page on the same site, it assumes the domain name will be the same as the page we created the link on.",
                detail1:"Relative links only include the file path to the other page, relative to the page you are creating the link on. This is quite abstract, let’s see this in action using an example.",
                detail2:"Within ```the msb-links-and-images``` directory, create another HTML file named about.html and paste the following code into it:",
                detail3:"Back in the index page, add the following anchor element to create a link to the about page:",
                detail4:"Open the index file in a browser and click on the about link to make sure it is all wired together correctly. Clicking the link should go to the about page we just created.",
                detail5:"This works because the index and about page are in the same directory. That means we can simply use its name (about.html) as the link’s href value.",
                detail6:"But we will usually want to organize our website directories a little better. Normally we would only have the index.html at the root directory and all other HTML files in their own directory.",
                detail7:"Create a directory named pages within the odin-links-and-images directory and move the about.html file into this new directory.",
                detail8:"Refresh the index page in the browser and then click on the about link. It will now be broken. This is because the location of the about page file has changed.",
                detail9:"To fix this, we just need to update the about link href value to include the pages/ directory since that is the new location of the about file relative to the index file.",
                detail10:"Refresh the index page in the browser and try clicking the about link again, it should now be back in working order.",
                detail11:"In many cases, this will work just fine; however, you can still run into unexpected issues with this approach. Prepending ./ before the link will in most cases prevent such issues. By adding ./ you are specifying to your code that it should start looking for the file/directory relative to the current directory.",
                ancorName:"Relative Links",
                popup1Name:"relative link",
                popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653643895/msbGeanologyProfilePics/relative_link_td1h2t.png",
                popup2Name:"absolute link",
                popup2:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644249/msbGeanologyProfilePics/absolutlink_vmo5o6.png",
                },
                {
                name:'A Metaphor',
                detail:"Absolute and relative links are a tricky concept to build a good mental model of, a metaphor may help:",
                detail1:"Think of your domain name (town.com) as a town, the directory in which your website is located (/museum) as a museum, and each page on your website as a room in the museum (/museum/movie_room.html and /museum/shops/coffee_shop.html). Relative links like ./shops/coffee_shop.html are directions from the current room (the museum movie room /museum/movie_room.html) to another room (the museum shop). Absolute links, on the other hand, are full directions including the protocol (https), domain name (town.com) and the path from that domain name (/museum/shops/coffee_shop.html): https://town.com/museum/shops/coffee_shop.html.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"A Metaphor",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Images',
                detail:"Websites would be fairly boring if they could only display text. Luckily HTML provides a wide variety of elements for displaying all sorts of different media. The most widely used of these is the image element.",
                detail1:"To display an image in HTML we use the <img> element. Unlike the other elements we have encountered so far, the <img> element is empty. Which means it doesn’t have a closing tag.",
                detail2:"Instead of wrapping content with an opening and closing tag, it embeds an image into the page using a src attribute which tells the browser where the image file is located. The src attribute works much like the href attribute for anchor tags. It can embed an image using both absolute and relative paths.",
                detail3:"For example, using an absolute path we can display an image located on The Odin Project site:",
                detail4:"To use images that we have on our own websites, we can use a relative path.",
                detail5:"1. Create a new directory named images within the odin-links-and-images project.",
                detail6:"2. Next, download this image and move it into the images directory we just created.(check the link to download in the source)",
                detail7:"3. Rename the image to dog.jpg.",
                detail8:"Finally add the image to the index.html file:",
                detail9:"Save the index.html file and open it in a browser to view Charles in all his glory.",
                ancorName:"Images",
                popup1Name:"image display",
                popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644641/msbGeanologyProfilePics/images_aqfnin.png",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Parent Directories',
                detail:"What if we want to use the dog image in the about page? We would first have to go up one level out of the pages directory into its parent directory so we could then access the images directory.",
                detail1:"To go to the parent directory we need to use two dots in the relative filepath like this: ../. Let’s see this in action, within the body of the about.html file, add the following image below the heading we added earlier:",
                detail2:'<img src="../images/dog.jpg">',
                detail3:"To break this down:",
                detail4:"1. First, we are going to the parent directory of the pages directory which is odin-links-and-images.",
                detail5:"2. Then, from the parent directory, we can go into the images directory.",
                detail6:"3. Finally, we can access the dog.jpg file.",
                detail7:"Using the metaphor we used earlier, using ../ in a filepath is kind of like stepping out from the room you are currently in to the main hallway so you can go to another room.",
                ancorName:"Parent Directories",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Alt attribute',
                detail:"Besides the src attribute, every image element should also have an alt (alternative text) attribute.",
                detail1:"The alt attribute is used to describe an image. It will be used in place of the image if it cannot be loaded. It is also used with screen readers to describe what the image is to visually impaired users.",
                detail2:"This is how the The Odin Project logo example we used earlier looks with an alt attribute included:",
                detail3:"As a bit of practice, add an alt attribute to the dog image we added to the odin-links-and-images project.",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Alt attribute",
                popup1Name:"alt atribute",
                popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653646504/msbGeanologyProfilePics/image_atribute_ujkhst.png",
                popup2Name:"",
                popup2:"",
                },
                
                {
                name:'Assignment',
                detail:"Watch Kevin Powell’s HTML Links Video.",
                detail1:"Watch Kevin Powell’s HTML Images Video.",
                detail2:"Watch Kevin Powell’s File Structure Video.",
                detail3:"Read about the four main image formats that can be used on the web.",
                detail4:" ",
                detail5:"",
                detail6:"",
                ancorName:"Assignment",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                {
                name:'',
                detail:"",
                detail1:"",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                {
                title:"Watch Kevin Powell’s HTML Images Video",
                url:"https://www.youtube.com/watch?v=0xoztJCHpbQ&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=6"
                },
                {
                title:"Watch Kevin Powell’s File Structure Video.",
                url:"https://www.youtube.com/watch?v=ta3Oxx7Yqbo&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=7"
                },
                {
                title:"Read about the four main image formats that can be used on the web.",
                url:"https://www.internetingishard.com/html-and-css/links-and-images/#image-formats"
                },
                {
                title:"Interneting is hard’s treatment on HTML links and images",
                url:"https://www.internetingishard.com/html-and-css/links-and-images/"
                },
                {
                title:"What happened the day Google decided links including (/) were malware",
                url:"https://www.itpro.co.uk/609724/google-apologises-after-blacklisting-entire-internet"
                },
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  {
                    check:"What is an attribute?"
                  },
                  {
                    check:"What attribute tells links where to go to?"
                  },
                  {
                    check:"What is the difference between an absolute and relative link?"
                  },
                
                  {
                    check:"Which element is used to display an image?"
                  },
                  {
                    check:"What two attributes do images always need to have?"
                  },
                  {
                    check:"How do you access a parent directory in a filepath?"
                  },
                  {
                    check:"What are the four main image formats that you can use for images on the web?"
                  },
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[],
                
              },
             
            ]
          },

          {
            name:"Social Media",
            courseStatus:"Incomplete",
            
            courseNumber:"006",
            logo:logo2,
            menu:[
            {
            name:'Introduction',
            detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
            detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Introduction",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Lesson Overview',
            detail:"This section contains a general overview of topics that you will learn in this lesson.",
            detail1:"1.)How to create links to pages on other websites on the internet",
            detail2:"2.)How to create links to other pages on your own websites",
            detail3:"3.)The difference between absolute and relative links",
            detail4:"4.)How to display an image on webpage using HTML",
            detail5:"",
            detail6:"",
            ancorName:"Lesson Overview",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Preparation',
            detail:"To get some practice using links and images throughout this lesson we need an HTML project to work with.",
            detail1:"1. Create a new directory named ```msb-links-and-images```.",
            detail2:"2. Within that directory, create a new file named index.html.",
            detail3:"3. Fill in the usual HTML boilerplate.",
            detail4:"4. Finally, add the following h1 to the body:",
            detail5:" <h1>Homepage</h1>",
            detail6:"",
            ancorName:"Preparation",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Anchor Elements',
            detail:"To create a link in HTML, we use the anchor element. An anchor element is defined by wrapping the text or another HTML element we want to be a link with an <a> tag.",
            detail1:"Add the following to the body of the index.html page we created and open it in the browser:",
            detail2:"<a>click me</a>",
            detail3:"You may have noticed that clicking this link doesn’t do anything. This is because an anchor tag on its own won’t know where we want to link to. We have to tell it a destination to go to. We do this by using an HTML attribute.",
            detail4:"An HTML attribute gives additional information to an HTML element and always goes in the element’s opening tag. An attribute is made up of two parts, a name, and a value. In our case, we need to add a href (hyperlink reference) attribute to the opening anchor tag. The value of the href attribute is the destination we want our link to go to.",
            detail5:"Add the following href attribute to the anchor element we created previously and try clicking it again, don’t forget to refresh the browser so the new changes can be applied.",
            detail6:'<a href="https://www.theodinproject.com/about">click me</a>',
            detail7:'By default, any text wrapped with an anchor tag without a href attribute will look like plain text. If the href attribute is present, the browser will give the text a blue color and underline it to signify it is a link.',
            detail8:'It’s worth noting you can use anchor tags to link to any kind of resource on the internet, not just other HTML documents. You can link to videos, pdf files, images, and so on, but for the most part, you will be linking to other HTML documents.',
            ancorName:"",
            popup1Name:"Anchor Elements",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Absolute and Relative Links',
            detail:"Generally, there are two kinds of links we will create:",
            detail1:"1. Links to pages on other websites on the internet",
            detail2:"2. Links to pages located on our own websites",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Absolute and Relative Links",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Absolute Links',
            detail:"Links to pages on other websites on the internet are called absolute links. A typical absolute link will be made up of the following parts: protocol://domain/path. An absolute link will always contain the protocol and domain of the destination.",
            detail1:"We’ve already seen an absolute link in action. The link we created to The Odin Project’s About page earlier was an absolute link as it contains the protocol and domain.",
            detail2:"https://www.project.com/about",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Absolute Links",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Relative Links',
            detail:"Links to other pages within our own website are called relative links. Relative links do not include the domain name, since it is another page on the same site, it assumes the domain name will be the same as the page we created the link on.",
            detail1:"Relative links only include the file path to the other page, relative to the page you are creating the link on. This is quite abstract, let’s see this in action using an example.",
            detail2:"Within ```the msb-links-and-images``` directory, create another HTML file named about.html and paste the following code into it:",
            detail3:"Back in the index page, add the following anchor element to create a link to the about page:",
            detail4:"Open the index file in a browser and click on the about link to make sure it is all wired together correctly. Clicking the link should go to the about page we just created.",
            detail5:"This works because the index and about page are in the same directory. That means we can simply use its name (about.html) as the link’s href value.",
            detail6:"But we will usually want to organize our website directories a little better. Normally we would only have the index.html at the root directory and all other HTML files in their own directory.",
            detail7:"Create a directory named pages within the odin-links-and-images directory and move the about.html file into this new directory.",
            detail8:"Refresh the index page in the browser and then click on the about link. It will now be broken. This is because the location of the about page file has changed.",
            detail9:"To fix this, we just need to update the about link href value to include the pages/ directory since that is the new location of the about file relative to the index file.",
            detail10:"Refresh the index page in the browser and try clicking the about link again, it should now be back in working order.",
            detail11:"In many cases, this will work just fine; however, you can still run into unexpected issues with this approach. Prepending ./ before the link will in most cases prevent such issues. By adding ./ you are specifying to your code that it should start looking for the file/directory relative to the current directory.",
            ancorName:"Relative Links",
            popup1Name:"relative link",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653643895/msbGeanologyProfilePics/relative_link_td1h2t.png",
            popup2Name:"absolute link",
            popup2:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644249/msbGeanologyProfilePics/absolutlink_vmo5o6.png",
            },
            {
            name:'A Metaphor',
            detail:"Absolute and relative links are a tricky concept to build a good mental model of, a metaphor may help:",
            detail1:"Think of your domain name (town.com) as a town, the directory in which your website is located (/museum) as a museum, and each page on your website as a room in the museum (/museum/movie_room.html and /museum/shops/coffee_shop.html). Relative links like ./shops/coffee_shop.html are directions from the current room (the museum movie room /museum/movie_room.html) to another room (the museum shop). Absolute links, on the other hand, are full directions including the protocol (https), domain name (town.com) and the path from that domain name (/museum/shops/coffee_shop.html): https://town.com/museum/shops/coffee_shop.html.",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"A Metaphor",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Images',
            detail:"Websites would be fairly boring if they could only display text. Luckily HTML provides a wide variety of elements for displaying all sorts of different media. The most widely used of these is the image element.",
            detail1:"To display an image in HTML we use the <img> element. Unlike the other elements we have encountered so far, the <img> element is empty. Which means it doesn’t have a closing tag.",
            detail2:"Instead of wrapping content with an opening and closing tag, it embeds an image into the page using a src attribute which tells the browser where the image file is located. The src attribute works much like the href attribute for anchor tags. It can embed an image using both absolute and relative paths.",
            detail3:"For example, using an absolute path we can display an image located on The Odin Project site:",
            detail4:"To use images that we have on our own websites, we can use a relative path.",
            detail5:"1. Create a new directory named images within the odin-links-and-images project.",
            detail6:"2. Next, download this image and move it into the images directory we just created.(check the link to download in the source)",
            detail7:"3. Rename the image to dog.jpg.",
            detail8:"Finally add the image to the index.html file:",
            detail9:"Save the index.html file and open it in a browser to view Charles in all his glory.",
            ancorName:"Images",
            popup1Name:"image display",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644641/msbGeanologyProfilePics/images_aqfnin.png",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Parent Directories',
            detail:"What if we want to use the dog image in the about page? We would first have to go up one level out of the pages directory into its parent directory so we could then access the images directory.",
            detail1:"To go to the parent directory we need to use two dots in the relative filepath like this: ../. Let’s see this in action, within the body of the about.html file, add the following image below the heading we added earlier:",
            detail2:'<img src="../images/dog.jpg">',
            detail3:"To break this down:",
            detail4:"1. First, we are going to the parent directory of the pages directory which is odin-links-and-images.",
            detail5:"2. Then, from the parent directory, we can go into the images directory.",
            detail6:"3. Finally, we can access the dog.jpg file.",
            detail7:"Using the metaphor we used earlier, using ../ in a filepath is kind of like stepping out from the room you are currently in to the main hallway so you can go to another room.",
            ancorName:"Parent Directories",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Alt attribute',
            detail:"Besides the src attribute, every image element should also have an alt (alternative text) attribute.",
            detail1:"The alt attribute is used to describe an image. It will be used in place of the image if it cannot be loaded. It is also used with screen readers to describe what the image is to visually impaired users.",
            detail2:"This is how the The Odin Project logo example we used earlier looks with an alt attribute included:",
            detail3:"As a bit of practice, add an alt attribute to the dog image we added to the odin-links-and-images project.",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Alt attribute",
            popup1Name:"alt atribute",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653646504/msbGeanologyProfilePics/image_atribute_ujkhst.png",
            popup2Name:"",
            popup2:"",
            },
            
            {
            name:'Assignment',
            detail:"Watch Kevin Powell’s HTML Links Video.",
            detail1:"Watch Kevin Powell’s HTML Images Video.",
            detail2:"Watch Kevin Powell’s File Structure Video.",
            detail3:"Read about the four main image formats that can be used on the web.",
            detail4:" ",
            detail5:"",
            detail6:"",
            ancorName:"Assignment",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            
            {
            name:'',
            detail:"",
            detail1:"",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            ],
            additionalRead:[
            {
            title:"Watch Kevin Powell’s HTML Links Video.",
            url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
            },
            {
            title:"Watch Kevin Powell’s HTML Images Video",
            url:"https://www.youtube.com/watch?v=0xoztJCHpbQ&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=6"
            },
            {
            title:"Watch Kevin Powell’s File Structure Video.",
            url:"https://www.youtube.com/watch?v=ta3Oxx7Yqbo&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=7"
            },
            {
            title:"Read about the four main image formats that can be used on the web.",
            url:"https://www.internetingishard.com/html-and-css/links-and-images/#image-formats"
            },
            {
            title:"Interneting is hard’s treatment on HTML links and images",
            url:"https://www.internetingishard.com/html-and-css/links-and-images/"
            },
            {
            title:"What happened the day Google decided links including (/) were malware",
            url:"https://www.itpro.co.uk/609724/google-apologises-after-blacklisting-entire-internet"
            },
            ],
            KnowledgeCheck:[
              {
                check:"What element is used to create a link?"
              },
              {
                check:"What is an attribute?"
              },
              {
                check:"What attribute tells links where to go to?"
              },
              {
                check:"What is the difference between an absolute and relative link?"
              },
            
              {
                check:"Which element is used to display an image?"
              },
              {
                check:"What two attributes do images always need to have?"
              },
              {
                check:"How do you access a parent directory in a filepath?"
              },
              {
                check:"What are the four main image formats that you can use for images on the web?"
              },
            ],
            source:[
            {
            name:"TheodinProject",
            link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
            },
            {
            name:"download image ",
            link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
            },
            ],
            people:[],
            companyLevel5:[
              {
                name:"LinkedIn",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Lesson Overview',
                detail:"This section contains a general overview of topics that you will learn in this lesson.",
                detail1:"1.)How to create links to pages on other websites on the internet",
                detail2:"2.)How to create links to other pages on your own websites",
                detail3:"3.)The difference between absolute and relative links",
                detail4:"4.)How to display an image on webpage using HTML",
                detail5:"",
                detail6:"",
                ancorName:"Lesson Overview",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Preparation',
                detail:"To get some practice using links and images throughout this lesson we need an HTML project to work with.",
                detail1:"1. Create a new directory named ```msb-links-and-images```.",
                detail2:"2. Within that directory, create a new file named index.html.",
                detail3:"3. Fill in the usual HTML boilerplate.",
                detail4:"4. Finally, add the following h1 to the body:",
                detail5:" <h1>Homepage</h1>",
                detail6:"",
                ancorName:"Preparation",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Anchor Elements',
                detail:"To create a link in HTML, we use the anchor element. An anchor element is defined by wrapping the text or another HTML element we want to be a link with an <a> tag.",
                detail1:"Add the following to the body of the index.html page we created and open it in the browser:",
                detail2:"<a>click me</a>",
                detail3:"You may have noticed that clicking this link doesn’t do anything. This is because an anchor tag on its own won’t know where we want to link to. We have to tell it a destination to go to. We do this by using an HTML attribute.",
                detail4:"An HTML attribute gives additional information to an HTML element and always goes in the element’s opening tag. An attribute is made up of two parts, a name, and a value. In our case, we need to add a href (hyperlink reference) attribute to the opening anchor tag. The value of the href attribute is the destination we want our link to go to.",
                detail5:"Add the following href attribute to the anchor element we created previously and try clicking it again, don’t forget to refresh the browser so the new changes can be applied.",
                detail6:'<a href="https://www.theodinproject.com/about">click me</a>',
                detail7:'By default, any text wrapped with an anchor tag without a href attribute will look like plain text. If the href attribute is present, the browser will give the text a blue color and underline it to signify it is a link.',
                detail8:'It’s worth noting you can use anchor tags to link to any kind of resource on the internet, not just other HTML documents. You can link to videos, pdf files, images, and so on, but for the most part, you will be linking to other HTML documents.',
                ancorName:"",
                popup1Name:"Anchor Elements",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Absolute and Relative Links',
                detail:"Generally, there are two kinds of links we will create:",
                detail1:"1. Links to pages on other websites on the internet",
                detail2:"2. Links to pages located on our own websites",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Absolute and Relative Links",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Absolute Links',
                detail:"Links to pages on other websites on the internet are called absolute links. A typical absolute link will be made up of the following parts: protocol://domain/path. An absolute link will always contain the protocol and domain of the destination.",
                detail1:"We’ve already seen an absolute link in action. The link we created to The Odin Project’s About page earlier was an absolute link as it contains the protocol and domain.",
                detail2:"https://www.project.com/about",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Absolute Links",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Relative Links',
                detail:"Links to other pages within our own website are called relative links. Relative links do not include the domain name, since it is another page on the same site, it assumes the domain name will be the same as the page we created the link on.",
                detail1:"Relative links only include the file path to the other page, relative to the page you are creating the link on. This is quite abstract, let’s see this in action using an example.",
                detail2:"Within ```the msb-links-and-images``` directory, create another HTML file named about.html and paste the following code into it:",
                detail3:"Back in the index page, add the following anchor element to create a link to the about page:",
                detail4:"Open the index file in a browser and click on the about link to make sure it is all wired together correctly. Clicking the link should go to the about page we just created.",
                detail5:"This works because the index and about page are in the same directory. That means we can simply use its name (about.html) as the link’s href value.",
                detail6:"But we will usually want to organize our website directories a little better. Normally we would only have the index.html at the root directory and all other HTML files in their own directory.",
                detail7:"Create a directory named pages within the odin-links-and-images directory and move the about.html file into this new directory.",
                detail8:"Refresh the index page in the browser and then click on the about link. It will now be broken. This is because the location of the about page file has changed.",
                detail9:"To fix this, we just need to update the about link href value to include the pages/ directory since that is the new location of the about file relative to the index file.",
                detail10:"Refresh the index page in the browser and try clicking the about link again, it should now be back in working order.",
                detail11:"In many cases, this will work just fine; however, you can still run into unexpected issues with this approach. Prepending ./ before the link will in most cases prevent such issues. By adding ./ you are specifying to your code that it should start looking for the file/directory relative to the current directory.",
                ancorName:"Relative Links",
                popup1Name:"relative link",
                popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653643895/msbGeanologyProfilePics/relative_link_td1h2t.png",
                popup2Name:"absolute link",
                popup2:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644249/msbGeanologyProfilePics/absolutlink_vmo5o6.png",
                },
                {
                name:'A Metaphor',
                detail:"Absolute and relative links are a tricky concept to build a good mental model of, a metaphor may help:",
                detail1:"Think of your domain name (town.com) as a town, the directory in which your website is located (/museum) as a museum, and each page on your website as a room in the museum (/museum/movie_room.html and /museum/shops/coffee_shop.html). Relative links like ./shops/coffee_shop.html are directions from the current room (the museum movie room /museum/movie_room.html) to another room (the museum shop). Absolute links, on the other hand, are full directions including the protocol (https), domain name (town.com) and the path from that domain name (/museum/shops/coffee_shop.html): https://town.com/museum/shops/coffee_shop.html.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"A Metaphor",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Images',
                detail:"Websites would be fairly boring if they could only display text. Luckily HTML provides a wide variety of elements for displaying all sorts of different media. The most widely used of these is the image element.",
                detail1:"To display an image in HTML we use the <img> element. Unlike the other elements we have encountered so far, the <img> element is empty. Which means it doesn’t have a closing tag.",
                detail2:"Instead of wrapping content with an opening and closing tag, it embeds an image into the page using a src attribute which tells the browser where the image file is located. The src attribute works much like the href attribute for anchor tags. It can embed an image using both absolute and relative paths.",
                detail3:"For example, using an absolute path we can display an image located on The Odin Project site:",
                detail4:"To use images that we have on our own websites, we can use a relative path.",
                detail5:"1. Create a new directory named images within the odin-links-and-images project.",
                detail6:"2. Next, download this image and move it into the images directory we just created.(check the link to download in the source)",
                detail7:"3. Rename the image to dog.jpg.",
                detail8:"Finally add the image to the index.html file:",
                detail9:"Save the index.html file and open it in a browser to view Charles in all his glory.",
                ancorName:"Images",
                popup1Name:"image display",
                popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644641/msbGeanologyProfilePics/images_aqfnin.png",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Parent Directories',
                detail:"What if we want to use the dog image in the about page? We would first have to go up one level out of the pages directory into its parent directory so we could then access the images directory.",
                detail1:"To go to the parent directory we need to use two dots in the relative filepath like this: ../. Let’s see this in action, within the body of the about.html file, add the following image below the heading we added earlier:",
                detail2:'<img src="../images/dog.jpg">',
                detail3:"To break this down:",
                detail4:"1. First, we are going to the parent directory of the pages directory which is odin-links-and-images.",
                detail5:"2. Then, from the parent directory, we can go into the images directory.",
                detail6:"3. Finally, we can access the dog.jpg file.",
                detail7:"Using the metaphor we used earlier, using ../ in a filepath is kind of like stepping out from the room you are currently in to the main hallway so you can go to another room.",
                ancorName:"Parent Directories",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Alt attribute',
                detail:"Besides the src attribute, every image element should also have an alt (alternative text) attribute.",
                detail1:"The alt attribute is used to describe an image. It will be used in place of the image if it cannot be loaded. It is also used with screen readers to describe what the image is to visually impaired users.",
                detail2:"This is how the The Odin Project logo example we used earlier looks with an alt attribute included:",
                detail3:"As a bit of practice, add an alt attribute to the dog image we added to the odin-links-and-images project.",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Alt attribute",
                popup1Name:"alt atribute",
                popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653646504/msbGeanologyProfilePics/image_atribute_ujkhst.png",
                popup2Name:"",
                popup2:"",
                },
                
                {
                name:'Assignment',
                detail:"Watch Kevin Powell’s HTML Links Video.",
                detail1:"Watch Kevin Powell’s HTML Images Video.",
                detail2:"Watch Kevin Powell’s File Structure Video.",
                detail3:"Read about the four main image formats that can be used on the web.",
                detail4:" ",
                detail5:"",
                detail6:"",
                ancorName:"Assignment",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                {
                name:'',
                detail:"",
                detail1:"",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                {
                title:"Watch Kevin Powell’s HTML Images Video",
                url:"https://www.youtube.com/watch?v=0xoztJCHpbQ&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=6"
                },
                {
                title:"Watch Kevin Powell’s File Structure Video.",
                url:"https://www.youtube.com/watch?v=ta3Oxx7Yqbo&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=7"
                },
                {
                title:"Read about the four main image formats that can be used on the web.",
                url:"https://www.internetingishard.com/html-and-css/links-and-images/#image-formats"
                },
                {
                title:"Interneting is hard’s treatment on HTML links and images",
                url:"https://www.internetingishard.com/html-and-css/links-and-images/"
                },
                {
                title:"What happened the day Google decided links including (/) were malware",
                url:"https://www.itpro.co.uk/609724/google-apologises-after-blacklisting-entire-internet"
                },
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  {
                    check:"What is an attribute?"
                  },
                  {
                    check:"What attribute tells links where to go to?"
                  },
                  {
                    check:"What is the difference between an absolute and relative link?"
                  },
                
                  {
                    check:"Which element is used to display an image?"
                  },
                  {
                    check:"What two attributes do images always need to have?"
                  },
                  {
                    check:"How do you access a parent directory in a filepath?"
                  },
                  {
                    check:"What are the four main image formats that you can use for images on the web?"
                  },
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[],
                
              },
              {
                name:"Facebook",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Lesson Overview',
                detail:"This section contains a general overview of topics that you will learn in this lesson.",
                detail1:"1.)How to create links to pages on other websites on the internet",
                detail2:"2.)How to create links to other pages on your own websites",
                detail3:"3.)The difference between absolute and relative links",
                detail4:"4.)How to display an image on webpage using HTML",
                detail5:"",
                detail6:"",
                ancorName:"Lesson Overview",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Preparation',
                detail:"To get some practice using links and images throughout this lesson we need an HTML project to work with.",
                detail1:"1. Create a new directory named ```msb-links-and-images```.",
                detail2:"2. Within that directory, create a new file named index.html.",
                detail3:"3. Fill in the usual HTML boilerplate.",
                detail4:"4. Finally, add the following h1 to the body:",
                detail5:" <h1>Homepage</h1>",
                detail6:"",
                ancorName:"Preparation",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Anchor Elements',
                detail:"To create a link in HTML, we use the anchor element. An anchor element is defined by wrapping the text or another HTML element we want to be a link with an <a> tag.",
                detail1:"Add the following to the body of the index.html page we created and open it in the browser:",
                detail2:"<a>click me</a>",
                detail3:"You may have noticed that clicking this link doesn’t do anything. This is because an anchor tag on its own won’t know where we want to link to. We have to tell it a destination to go to. We do this by using an HTML attribute.",
                detail4:"An HTML attribute gives additional information to an HTML element and always goes in the element’s opening tag. An attribute is made up of two parts, a name, and a value. In our case, we need to add a href (hyperlink reference) attribute to the opening anchor tag. The value of the href attribute is the destination we want our link to go to.",
                detail5:"Add the following href attribute to the anchor element we created previously and try clicking it again, don’t forget to refresh the browser so the new changes can be applied.",
                detail6:'<a href="https://www.theodinproject.com/about">click me</a>',
                detail7:'By default, any text wrapped with an anchor tag without a href attribute will look like plain text. If the href attribute is present, the browser will give the text a blue color and underline it to signify it is a link.',
                detail8:'It’s worth noting you can use anchor tags to link to any kind of resource on the internet, not just other HTML documents. You can link to videos, pdf files, images, and so on, but for the most part, you will be linking to other HTML documents.',
                ancorName:"",
                popup1Name:"Anchor Elements",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Absolute and Relative Links',
                detail:"Generally, there are two kinds of links we will create:",
                detail1:"1. Links to pages on other websites on the internet",
                detail2:"2. Links to pages located on our own websites",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Absolute and Relative Links",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Absolute Links',
                detail:"Links to pages on other websites on the internet are called absolute links. A typical absolute link will be made up of the following parts: protocol://domain/path. An absolute link will always contain the protocol and domain of the destination.",
                detail1:"We’ve already seen an absolute link in action. The link we created to The Odin Project’s About page earlier was an absolute link as it contains the protocol and domain.",
                detail2:"https://www.project.com/about",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Absolute Links",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Relative Links',
                detail:"Links to other pages within our own website are called relative links. Relative links do not include the domain name, since it is another page on the same site, it assumes the domain name will be the same as the page we created the link on.",
                detail1:"Relative links only include the file path to the other page, relative to the page you are creating the link on. This is quite abstract, let’s see this in action using an example.",
                detail2:"Within ```the msb-links-and-images``` directory, create another HTML file named about.html and paste the following code into it:",
                detail3:"Back in the index page, add the following anchor element to create a link to the about page:",
                detail4:"Open the index file in a browser and click on the about link to make sure it is all wired together correctly. Clicking the link should go to the about page we just created.",
                detail5:"This works because the index and about page are in the same directory. That means we can simply use its name (about.html) as the link’s href value.",
                detail6:"But we will usually want to organize our website directories a little better. Normally we would only have the index.html at the root directory and all other HTML files in their own directory.",
                detail7:"Create a directory named pages within the odin-links-and-images directory and move the about.html file into this new directory.",
                detail8:"Refresh the index page in the browser and then click on the about link. It will now be broken. This is because the location of the about page file has changed.",
                detail9:"To fix this, we just need to update the about link href value to include the pages/ directory since that is the new location of the about file relative to the index file.",
                detail10:"Refresh the index page in the browser and try clicking the about link again, it should now be back in working order.",
                detail11:"In many cases, this will work just fine; however, you can still run into unexpected issues with this approach. Prepending ./ before the link will in most cases prevent such issues. By adding ./ you are specifying to your code that it should start looking for the file/directory relative to the current directory.",
                ancorName:"Relative Links",
                popup1Name:"relative link",
                popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653643895/msbGeanologyProfilePics/relative_link_td1h2t.png",
                popup2Name:"absolute link",
                popup2:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644249/msbGeanologyProfilePics/absolutlink_vmo5o6.png",
                },
                {
                name:'A Metaphor',
                detail:"Absolute and relative links are a tricky concept to build a good mental model of, a metaphor may help:",
                detail1:"Think of your domain name (town.com) as a town, the directory in which your website is located (/museum) as a museum, and each page on your website as a room in the museum (/museum/movie_room.html and /museum/shops/coffee_shop.html). Relative links like ./shops/coffee_shop.html are directions from the current room (the museum movie room /museum/movie_room.html) to another room (the museum shop). Absolute links, on the other hand, are full directions including the protocol (https), domain name (town.com) and the path from that domain name (/museum/shops/coffee_shop.html): https://town.com/museum/shops/coffee_shop.html.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"A Metaphor",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Images',
                detail:"Websites would be fairly boring if they could only display text. Luckily HTML provides a wide variety of elements for displaying all sorts of different media. The most widely used of these is the image element.",
                detail1:"To display an image in HTML we use the <img> element. Unlike the other elements we have encountered so far, the <img> element is empty. Which means it doesn’t have a closing tag.",
                detail2:"Instead of wrapping content with an opening and closing tag, it embeds an image into the page using a src attribute which tells the browser where the image file is located. The src attribute works much like the href attribute for anchor tags. It can embed an image using both absolute and relative paths.",
                detail3:"For example, using an absolute path we can display an image located on The Odin Project site:",
                detail4:"To use images that we have on our own websites, we can use a relative path.",
                detail5:"1. Create a new directory named images within the odin-links-and-images project.",
                detail6:"2. Next, download this image and move it into the images directory we just created.(check the link to download in the source)",
                detail7:"3. Rename the image to dog.jpg.",
                detail8:"Finally add the image to the index.html file:",
                detail9:"Save the index.html file and open it in a browser to view Charles in all his glory.",
                ancorName:"Images",
                popup1Name:"image display",
                popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644641/msbGeanologyProfilePics/images_aqfnin.png",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Parent Directories',
                detail:"What if we want to use the dog image in the about page? We would first have to go up one level out of the pages directory into its parent directory so we could then access the images directory.",
                detail1:"To go to the parent directory we need to use two dots in the relative filepath like this: ../. Let’s see this in action, within the body of the about.html file, add the following image below the heading we added earlier:",
                detail2:'<img src="../images/dog.jpg">',
                detail3:"To break this down:",
                detail4:"1. First, we are going to the parent directory of the pages directory which is odin-links-and-images.",
                detail5:"2. Then, from the parent directory, we can go into the images directory.",
                detail6:"3. Finally, we can access the dog.jpg file.",
                detail7:"Using the metaphor we used earlier, using ../ in a filepath is kind of like stepping out from the room you are currently in to the main hallway so you can go to another room.",
                ancorName:"Parent Directories",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Alt attribute',
                detail:"Besides the src attribute, every image element should also have an alt (alternative text) attribute.",
                detail1:"The alt attribute is used to describe an image. It will be used in place of the image if it cannot be loaded. It is also used with screen readers to describe what the image is to visually impaired users.",
                detail2:"This is how the The Odin Project logo example we used earlier looks with an alt attribute included:",
                detail3:"As a bit of practice, add an alt attribute to the dog image we added to the odin-links-and-images project.",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Alt attribute",
                popup1Name:"alt atribute",
                popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653646504/msbGeanologyProfilePics/image_atribute_ujkhst.png",
                popup2Name:"",
                popup2:"",
                },
                
                {
                name:'Assignment',
                detail:"Watch Kevin Powell’s HTML Links Video.",
                detail1:"Watch Kevin Powell’s HTML Images Video.",
                detail2:"Watch Kevin Powell’s File Structure Video.",
                detail3:"Read about the four main image formats that can be used on the web.",
                detail4:" ",
                detail5:"",
                detail6:"",
                ancorName:"Assignment",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                {
                name:'',
                detail:"",
                detail1:"",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                {
                title:"Watch Kevin Powell’s HTML Images Video",
                url:"https://www.youtube.com/watch?v=0xoztJCHpbQ&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=6"
                },
                {
                title:"Watch Kevin Powell’s File Structure Video.",
                url:"https://www.youtube.com/watch?v=ta3Oxx7Yqbo&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=7"
                },
                {
                title:"Read about the four main image formats that can be used on the web.",
                url:"https://www.internetingishard.com/html-and-css/links-and-images/#image-formats"
                },
                {
                title:"Interneting is hard’s treatment on HTML links and images",
                url:"https://www.internetingishard.com/html-and-css/links-and-images/"
                },
                {
                title:"What happened the day Google decided links including (/) were malware",
                url:"https://www.itpro.co.uk/609724/google-apologises-after-blacklisting-entire-internet"
                },
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  {
                    check:"What is an attribute?"
                  },
                  {
                    check:"What attribute tells links where to go to?"
                  },
                  {
                    check:"What is the difference between an absolute and relative link?"
                  },
                
                  {
                    check:"Which element is used to display an image?"
                  },
                  {
                    check:"What two attributes do images always need to have?"
                  },
                  {
                    check:"How do you access a parent directory in a filepath?"
                  },
                  {
                    check:"What are the four main image formats that you can use for images on the web?"
                  },
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[],
                
              },
              {
                name:"whatsapp",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Lesson Overview',
                detail:"This section contains a general overview of topics that you will learn in this lesson.",
                detail1:"1.)How to create links to pages on other websites on the internet",
                detail2:"2.)How to create links to other pages on your own websites",
                detail3:"3.)The difference between absolute and relative links",
                detail4:"4.)How to display an image on webpage using HTML",
                detail5:"",
                detail6:"",
                ancorName:"Lesson Overview",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Preparation',
                detail:"To get some practice using links and images throughout this lesson we need an HTML project to work with.",
                detail1:"1. Create a new directory named ```msb-links-and-images```.",
                detail2:"2. Within that directory, create a new file named index.html.",
                detail3:"3. Fill in the usual HTML boilerplate.",
                detail4:"4. Finally, add the following h1 to the body:",
                detail5:" <h1>Homepage</h1>",
                detail6:"",
                ancorName:"Preparation",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Anchor Elements',
                detail:"To create a link in HTML, we use the anchor element. An anchor element is defined by wrapping the text or another HTML element we want to be a link with an <a> tag.",
                detail1:"Add the following to the body of the index.html page we created and open it in the browser:",
                detail2:"<a>click me</a>",
                detail3:"You may have noticed that clicking this link doesn’t do anything. This is because an anchor tag on its own won’t know where we want to link to. We have to tell it a destination to go to. We do this by using an HTML attribute.",
                detail4:"An HTML attribute gives additional information to an HTML element and always goes in the element’s opening tag. An attribute is made up of two parts, a name, and a value. In our case, we need to add a href (hyperlink reference) attribute to the opening anchor tag. The value of the href attribute is the destination we want our link to go to.",
                detail5:"Add the following href attribute to the anchor element we created previously and try clicking it again, don’t forget to refresh the browser so the new changes can be applied.",
                detail6:'<a href="https://www.theodinproject.com/about">click me</a>',
                detail7:'By default, any text wrapped with an anchor tag without a href attribute will look like plain text. If the href attribute is present, the browser will give the text a blue color and underline it to signify it is a link.',
                detail8:'It’s worth noting you can use anchor tags to link to any kind of resource on the internet, not just other HTML documents. You can link to videos, pdf files, images, and so on, but for the most part, you will be linking to other HTML documents.',
                ancorName:"",
                popup1Name:"Anchor Elements",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Absolute and Relative Links',
                detail:"Generally, there are two kinds of links we will create:",
                detail1:"1. Links to pages on other websites on the internet",
                detail2:"2. Links to pages located on our own websites",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Absolute and Relative Links",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Absolute Links',
                detail:"Links to pages on other websites on the internet are called absolute links. A typical absolute link will be made up of the following parts: protocol://domain/path. An absolute link will always contain the protocol and domain of the destination.",
                detail1:"We’ve already seen an absolute link in action. The link we created to The Odin Project’s About page earlier was an absolute link as it contains the protocol and domain.",
                detail2:"https://www.project.com/about",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Absolute Links",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Relative Links',
                detail:"Links to other pages within our own website are called relative links. Relative links do not include the domain name, since it is another page on the same site, it assumes the domain name will be the same as the page we created the link on.",
                detail1:"Relative links only include the file path to the other page, relative to the page you are creating the link on. This is quite abstract, let’s see this in action using an example.",
                detail2:"Within ```the msb-links-and-images``` directory, create another HTML file named about.html and paste the following code into it:",
                detail3:"Back in the index page, add the following anchor element to create a link to the about page:",
                detail4:"Open the index file in a browser and click on the about link to make sure it is all wired together correctly. Clicking the link should go to the about page we just created.",
                detail5:"This works because the index and about page are in the same directory. That means we can simply use its name (about.html) as the link’s href value.",
                detail6:"But we will usually want to organize our website directories a little better. Normally we would only have the index.html at the root directory and all other HTML files in their own directory.",
                detail7:"Create a directory named pages within the odin-links-and-images directory and move the about.html file into this new directory.",
                detail8:"Refresh the index page in the browser and then click on the about link. It will now be broken. This is because the location of the about page file has changed.",
                detail9:"To fix this, we just need to update the about link href value to include the pages/ directory since that is the new location of the about file relative to the index file.",
                detail10:"Refresh the index page in the browser and try clicking the about link again, it should now be back in working order.",
                detail11:"In many cases, this will work just fine; however, you can still run into unexpected issues with this approach. Prepending ./ before the link will in most cases prevent such issues. By adding ./ you are specifying to your code that it should start looking for the file/directory relative to the current directory.",
                ancorName:"Relative Links",
                popup1Name:"relative link",
                popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653643895/msbGeanologyProfilePics/relative_link_td1h2t.png",
                popup2Name:"absolute link",
                popup2:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644249/msbGeanologyProfilePics/absolutlink_vmo5o6.png",
                },
                {
                name:'A Metaphor',
                detail:"Absolute and relative links are a tricky concept to build a good mental model of, a metaphor may help:",
                detail1:"Think of your domain name (town.com) as a town, the directory in which your website is located (/museum) as a museum, and each page on your website as a room in the museum (/museum/movie_room.html and /museum/shops/coffee_shop.html). Relative links like ./shops/coffee_shop.html are directions from the current room (the museum movie room /museum/movie_room.html) to another room (the museum shop). Absolute links, on the other hand, are full directions including the protocol (https), domain name (town.com) and the path from that domain name (/museum/shops/coffee_shop.html): https://town.com/museum/shops/coffee_shop.html.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"A Metaphor",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Images',
                detail:"Websites would be fairly boring if they could only display text. Luckily HTML provides a wide variety of elements for displaying all sorts of different media. The most widely used of these is the image element.",
                detail1:"To display an image in HTML we use the <img> element. Unlike the other elements we have encountered so far, the <img> element is empty. Which means it doesn’t have a closing tag.",
                detail2:"Instead of wrapping content with an opening and closing tag, it embeds an image into the page using a src attribute which tells the browser where the image file is located. The src attribute works much like the href attribute for anchor tags. It can embed an image using both absolute and relative paths.",
                detail3:"For example, using an absolute path we can display an image located on The Odin Project site:",
                detail4:"To use images that we have on our own websites, we can use a relative path.",
                detail5:"1. Create a new directory named images within the odin-links-and-images project.",
                detail6:"2. Next, download this image and move it into the images directory we just created.(check the link to download in the source)",
                detail7:"3. Rename the image to dog.jpg.",
                detail8:"Finally add the image to the index.html file:",
                detail9:"Save the index.html file and open it in a browser to view Charles in all his glory.",
                ancorName:"Images",
                popup1Name:"image display",
                popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644641/msbGeanologyProfilePics/images_aqfnin.png",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Parent Directories',
                detail:"What if we want to use the dog image in the about page? We would first have to go up one level out of the pages directory into its parent directory so we could then access the images directory.",
                detail1:"To go to the parent directory we need to use two dots in the relative filepath like this: ../. Let’s see this in action, within the body of the about.html file, add the following image below the heading we added earlier:",
                detail2:'<img src="../images/dog.jpg">',
                detail3:"To break this down:",
                detail4:"1. First, we are going to the parent directory of the pages directory which is odin-links-and-images.",
                detail5:"2. Then, from the parent directory, we can go into the images directory.",
                detail6:"3. Finally, we can access the dog.jpg file.",
                detail7:"Using the metaphor we used earlier, using ../ in a filepath is kind of like stepping out from the room you are currently in to the main hallway so you can go to another room.",
                ancorName:"Parent Directories",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Alt attribute',
                detail:"Besides the src attribute, every image element should also have an alt (alternative text) attribute.",
                detail1:"The alt attribute is used to describe an image. It will be used in place of the image if it cannot be loaded. It is also used with screen readers to describe what the image is to visually impaired users.",
                detail2:"This is how the The Odin Project logo example we used earlier looks with an alt attribute included:",
                detail3:"As a bit of practice, add an alt attribute to the dog image we added to the odin-links-and-images project.",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Alt attribute",
                popup1Name:"alt atribute",
                popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653646504/msbGeanologyProfilePics/image_atribute_ujkhst.png",
                popup2Name:"",
                popup2:"",
                },
                
                {
                name:'Assignment',
                detail:"Watch Kevin Powell’s HTML Links Video.",
                detail1:"Watch Kevin Powell’s HTML Images Video.",
                detail2:"Watch Kevin Powell’s File Structure Video.",
                detail3:"Read about the four main image formats that can be used on the web.",
                detail4:" ",
                detail5:"",
                detail6:"",
                ancorName:"Assignment",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                {
                name:'',
                detail:"",
                detail1:"",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                {
                title:"Watch Kevin Powell’s HTML Images Video",
                url:"https://www.youtube.com/watch?v=0xoztJCHpbQ&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=6"
                },
                {
                title:"Watch Kevin Powell’s File Structure Video.",
                url:"https://www.youtube.com/watch?v=ta3Oxx7Yqbo&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=7"
                },
                {
                title:"Read about the four main image formats that can be used on the web.",
                url:"https://www.internetingishard.com/html-and-css/links-and-images/#image-formats"
                },
                {
                title:"Interneting is hard’s treatment on HTML links and images",
                url:"https://www.internetingishard.com/html-and-css/links-and-images/"
                },
                {
                title:"What happened the day Google decided links including (/) were malware",
                url:"https://www.itpro.co.uk/609724/google-apologises-after-blacklisting-entire-internet"
                },
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  {
                    check:"What is an attribute?"
                  },
                  {
                    check:"What attribute tells links where to go to?"
                  },
                  {
                    check:"What is the difference between an absolute and relative link?"
                  },
                
                  {
                    check:"Which element is used to display an image?"
                  },
                  {
                    check:"What two attributes do images always need to have?"
                  },
                  {
                    check:"How do you access a parent directory in a filepath?"
                  },
                  {
                    check:"What are the four main image formats that you can use for images on the web?"
                  },
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[],
                
              },
            ]
          },

          {
            name:"Online Events",
            courseStatus:"Incomplete",
            
            courseNumber:"006",
            logo:logo2,
            menu:[
            {
            name:'Introduction',
            detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
            detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Introduction",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Lesson Overview',
            detail:"This section contains a general overview of topics that you will learn in this lesson.",
            detail1:"1.)How to create links to pages on other websites on the internet",
            detail2:"2.)How to create links to other pages on your own websites",
            detail3:"3.)The difference between absolute and relative links",
            detail4:"4.)How to display an image on webpage using HTML",
            detail5:"",
            detail6:"",
            ancorName:"Lesson Overview",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Preparation',
            detail:"To get some practice using links and images throughout this lesson we need an HTML project to work with.",
            detail1:"1. Create a new directory named ```msb-links-and-images```.",
            detail2:"2. Within that directory, create a new file named index.html.",
            detail3:"3. Fill in the usual HTML boilerplate.",
            detail4:"4. Finally, add the following h1 to the body:",
            detail5:" <h1>Homepage</h1>",
            detail6:"",
            ancorName:"Preparation",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Anchor Elements',
            detail:"To create a link in HTML, we use the anchor element. An anchor element is defined by wrapping the text or another HTML element we want to be a link with an <a> tag.",
            detail1:"Add the following to the body of the index.html page we created and open it in the browser:",
            detail2:"<a>click me</a>",
            detail3:"You may have noticed that clicking this link doesn’t do anything. This is because an anchor tag on its own won’t know where we want to link to. We have to tell it a destination to go to. We do this by using an HTML attribute.",
            detail4:"An HTML attribute gives additional information to an HTML element and always goes in the element’s opening tag. An attribute is made up of two parts, a name, and a value. In our case, we need to add a href (hyperlink reference) attribute to the opening anchor tag. The value of the href attribute is the destination we want our link to go to.",
            detail5:"Add the following href attribute to the anchor element we created previously and try clicking it again, don’t forget to refresh the browser so the new changes can be applied.",
            detail6:'<a href="https://www.theodinproject.com/about">click me</a>',
            detail7:'By default, any text wrapped with an anchor tag without a href attribute will look like plain text. If the href attribute is present, the browser will give the text a blue color and underline it to signify it is a link.',
            detail8:'It’s worth noting you can use anchor tags to link to any kind of resource on the internet, not just other HTML documents. You can link to videos, pdf files, images, and so on, but for the most part, you will be linking to other HTML documents.',
            ancorName:"",
            popup1Name:"Anchor Elements",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Absolute and Relative Links',
            detail:"Generally, there are two kinds of links we will create:",
            detail1:"1. Links to pages on other websites on the internet",
            detail2:"2. Links to pages located on our own websites",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Absolute and Relative Links",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Absolute Links',
            detail:"Links to pages on other websites on the internet are called absolute links. A typical absolute link will be made up of the following parts: protocol://domain/path. An absolute link will always contain the protocol and domain of the destination.",
            detail1:"We’ve already seen an absolute link in action. The link we created to The Odin Project’s About page earlier was an absolute link as it contains the protocol and domain.",
            detail2:"https://www.project.com/about",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Absolute Links",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Relative Links',
            detail:"Links to other pages within our own website are called relative links. Relative links do not include the domain name, since it is another page on the same site, it assumes the domain name will be the same as the page we created the link on.",
            detail1:"Relative links only include the file path to the other page, relative to the page you are creating the link on. This is quite abstract, let’s see this in action using an example.",
            detail2:"Within ```the msb-links-and-images``` directory, create another HTML file named about.html and paste the following code into it:",
            detail3:"Back in the index page, add the following anchor element to create a link to the about page:",
            detail4:"Open the index file in a browser and click on the about link to make sure it is all wired together correctly. Clicking the link should go to the about page we just created.",
            detail5:"This works because the index and about page are in the same directory. That means we can simply use its name (about.html) as the link’s href value.",
            detail6:"But we will usually want to organize our website directories a little better. Normally we would only have the index.html at the root directory and all other HTML files in their own directory.",
            detail7:"Create a directory named pages within the odin-links-and-images directory and move the about.html file into this new directory.",
            detail8:"Refresh the index page in the browser and then click on the about link. It will now be broken. This is because the location of the about page file has changed.",
            detail9:"To fix this, we just need to update the about link href value to include the pages/ directory since that is the new location of the about file relative to the index file.",
            detail10:"Refresh the index page in the browser and try clicking the about link again, it should now be back in working order.",
            detail11:"In many cases, this will work just fine; however, you can still run into unexpected issues with this approach. Prepending ./ before the link will in most cases prevent such issues. By adding ./ you are specifying to your code that it should start looking for the file/directory relative to the current directory.",
            ancorName:"Relative Links",
            popup1Name:"relative link",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653643895/msbGeanologyProfilePics/relative_link_td1h2t.png",
            popup2Name:"absolute link",
            popup2:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644249/msbGeanologyProfilePics/absolutlink_vmo5o6.png",
            },
            {
            name:'A Metaphor',
            detail:"Absolute and relative links are a tricky concept to build a good mental model of, a metaphor may help:",
            detail1:"Think of your domain name (town.com) as a town, the directory in which your website is located (/museum) as a museum, and each page on your website as a room in the museum (/museum/movie_room.html and /museum/shops/coffee_shop.html). Relative links like ./shops/coffee_shop.html are directions from the current room (the museum movie room /museum/movie_room.html) to another room (the museum shop). Absolute links, on the other hand, are full directions including the protocol (https), domain name (town.com) and the path from that domain name (/museum/shops/coffee_shop.html): https://town.com/museum/shops/coffee_shop.html.",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"A Metaphor",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Images',
            detail:"Websites would be fairly boring if they could only display text. Luckily HTML provides a wide variety of elements for displaying all sorts of different media. The most widely used of these is the image element.",
            detail1:"To display an image in HTML we use the <img> element. Unlike the other elements we have encountered so far, the <img> element is empty. Which means it doesn’t have a closing tag.",
            detail2:"Instead of wrapping content with an opening and closing tag, it embeds an image into the page using a src attribute which tells the browser where the image file is located. The src attribute works much like the href attribute for anchor tags. It can embed an image using both absolute and relative paths.",
            detail3:"For example, using an absolute path we can display an image located on The Odin Project site:",
            detail4:"To use images that we have on our own websites, we can use a relative path.",
            detail5:"1. Create a new directory named images within the odin-links-and-images project.",
            detail6:"2. Next, download this image and move it into the images directory we just created.(check the link to download in the source)",
            detail7:"3. Rename the image to dog.jpg.",
            detail8:"Finally add the image to the index.html file:",
            detail9:"Save the index.html file and open it in a browser to view Charles in all his glory.",
            ancorName:"Images",
            popup1Name:"image display",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644641/msbGeanologyProfilePics/images_aqfnin.png",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Parent Directories',
            detail:"What if we want to use the dog image in the about page? We would first have to go up one level out of the pages directory into its parent directory so we could then access the images directory.",
            detail1:"To go to the parent directory we need to use two dots in the relative filepath like this: ../. Let’s see this in action, within the body of the about.html file, add the following image below the heading we added earlier:",
            detail2:'<img src="../images/dog.jpg">',
            detail3:"To break this down:",
            detail4:"1. First, we are going to the parent directory of the pages directory which is odin-links-and-images.",
            detail5:"2. Then, from the parent directory, we can go into the images directory.",
            detail6:"3. Finally, we can access the dog.jpg file.",
            detail7:"Using the metaphor we used earlier, using ../ in a filepath is kind of like stepping out from the room you are currently in to the main hallway so you can go to another room.",
            ancorName:"Parent Directories",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            {
            name:'Alt attribute',
            detail:"Besides the src attribute, every image element should also have an alt (alternative text) attribute.",
            detail1:"The alt attribute is used to describe an image. It will be used in place of the image if it cannot be loaded. It is also used with screen readers to describe what the image is to visually impaired users.",
            detail2:"This is how the The Odin Project logo example we used earlier looks with an alt attribute included:",
            detail3:"As a bit of practice, add an alt attribute to the dog image we added to the odin-links-and-images project.",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Alt attribute",
            popup1Name:"alt atribute",
            popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653646504/msbGeanologyProfilePics/image_atribute_ujkhst.png",
            popup2Name:"",
            popup2:"",
            },
            
            {
            name:'Assignment',
            detail:"Watch Kevin Powell’s HTML Links Video.",
            detail1:"Watch Kevin Powell’s HTML Images Video.",
            detail2:"Watch Kevin Powell’s File Structure Video.",
            detail3:"Read about the four main image formats that can be used on the web.",
            detail4:" ",
            detail5:"",
            detail6:"",
            ancorName:"Assignment",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            
            {
            name:'',
            detail:"",
            detail1:"",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            ],
            additionalRead:[
            {
            title:"Watch Kevin Powell’s HTML Links Video.",
            url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
            },
            {
            title:"Watch Kevin Powell’s HTML Images Video",
            url:"https://www.youtube.com/watch?v=0xoztJCHpbQ&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=6"
            },
            {
            title:"Watch Kevin Powell’s File Structure Video.",
            url:"https://www.youtube.com/watch?v=ta3Oxx7Yqbo&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=7"
            },
            {
            title:"Read about the four main image formats that can be used on the web.",
            url:"https://www.internetingishard.com/html-and-css/links-and-images/#image-formats"
            },
            {
            title:"Interneting is hard’s treatment on HTML links and images",
            url:"https://www.internetingishard.com/html-and-css/links-and-images/"
            },
            {
            title:"What happened the day Google decided links including (/) were malware",
            url:"https://www.itpro.co.uk/609724/google-apologises-after-blacklisting-entire-internet"
            },
            ],
            KnowledgeCheck:[
              {
                check:"What element is used to create a link?"
              },
              {
                check:"What is an attribute?"
              },
              {
                check:"What attribute tells links where to go to?"
              },
              {
                check:"What is the difference between an absolute and relative link?"
              },
            
              {
                check:"Which element is used to display an image?"
              },
              {
                check:"What two attributes do images always need to have?"
              },
              {
                check:"How do you access a parent directory in a filepath?"
              },
              {
                check:"What are the four main image formats that you can use for images on the web?"
              },
            ],
            source:[
            {
            name:"TheodinProject",
            link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
            },
            {
            name:"download image ",
            link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
            },
            ],
            people:[],
            companyLevel5:[
              {
                name:"email",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Lesson Overview',
                detail:"This section contains a general overview of topics that you will learn in this lesson.",
                detail1:"1.)How to create links to pages on other websites on the internet",
                detail2:"2.)How to create links to other pages on your own websites",
                detail3:"3.)The difference between absolute and relative links",
                detail4:"4.)How to display an image on webpage using HTML",
                detail5:"",
                detail6:"",
                ancorName:"Lesson Overview",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Preparation',
                detail:"To get some practice using links and images throughout this lesson we need an HTML project to work with.",
                detail1:"1. Create a new directory named ```msb-links-and-images```.",
                detail2:"2. Within that directory, create a new file named index.html.",
                detail3:"3. Fill in the usual HTML boilerplate.",
                detail4:"4. Finally, add the following h1 to the body:",
                detail5:" <h1>Homepage</h1>",
                detail6:"",
                ancorName:"Preparation",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Anchor Elements',
                detail:"To create a link in HTML, we use the anchor element. An anchor element is defined by wrapping the text or another HTML element we want to be a link with an <a> tag.",
                detail1:"Add the following to the body of the index.html page we created and open it in the browser:",
                detail2:"<a>click me</a>",
                detail3:"You may have noticed that clicking this link doesn’t do anything. This is because an anchor tag on its own won’t know where we want to link to. We have to tell it a destination to go to. We do this by using an HTML attribute.",
                detail4:"An HTML attribute gives additional information to an HTML element and always goes in the element’s opening tag. An attribute is made up of two parts, a name, and a value. In our case, we need to add a href (hyperlink reference) attribute to the opening anchor tag. The value of the href attribute is the destination we want our link to go to.",
                detail5:"Add the following href attribute to the anchor element we created previously and try clicking it again, don’t forget to refresh the browser so the new changes can be applied.",
                detail6:'<a href="https://www.theodinproject.com/about">click me</a>',
                detail7:'By default, any text wrapped with an anchor tag without a href attribute will look like plain text. If the href attribute is present, the browser will give the text a blue color and underline it to signify it is a link.',
                detail8:'It’s worth noting you can use anchor tags to link to any kind of resource on the internet, not just other HTML documents. You can link to videos, pdf files, images, and so on, but for the most part, you will be linking to other HTML documents.',
                ancorName:"",
                popup1Name:"Anchor Elements",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Absolute and Relative Links',
                detail:"Generally, there are two kinds of links we will create:",
                detail1:"1. Links to pages on other websites on the internet",
                detail2:"2. Links to pages located on our own websites",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Absolute and Relative Links",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Absolute Links',
                detail:"Links to pages on other websites on the internet are called absolute links. A typical absolute link will be made up of the following parts: protocol://domain/path. An absolute link will always contain the protocol and domain of the destination.",
                detail1:"We’ve already seen an absolute link in action. The link we created to The Odin Project’s About page earlier was an absolute link as it contains the protocol and domain.",
                detail2:"https://www.project.com/about",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Absolute Links",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Relative Links',
                detail:"Links to other pages within our own website are called relative links. Relative links do not include the domain name, since it is another page on the same site, it assumes the domain name will be the same as the page we created the link on.",
                detail1:"Relative links only include the file path to the other page, relative to the page you are creating the link on. This is quite abstract, let’s see this in action using an example.",
                detail2:"Within ```the msb-links-and-images``` directory, create another HTML file named about.html and paste the following code into it:",
                detail3:"Back in the index page, add the following anchor element to create a link to the about page:",
                detail4:"Open the index file in a browser and click on the about link to make sure it is all wired together correctly. Clicking the link should go to the about page we just created.",
                detail5:"This works because the index and about page are in the same directory. That means we can simply use its name (about.html) as the link’s href value.",
                detail6:"But we will usually want to organize our website directories a little better. Normally we would only have the index.html at the root directory and all other HTML files in their own directory.",
                detail7:"Create a directory named pages within the odin-links-and-images directory and move the about.html file into this new directory.",
                detail8:"Refresh the index page in the browser and then click on the about link. It will now be broken. This is because the location of the about page file has changed.",
                detail9:"To fix this, we just need to update the about link href value to include the pages/ directory since that is the new location of the about file relative to the index file.",
                detail10:"Refresh the index page in the browser and try clicking the about link again, it should now be back in working order.",
                detail11:"In many cases, this will work just fine; however, you can still run into unexpected issues with this approach. Prepending ./ before the link will in most cases prevent such issues. By adding ./ you are specifying to your code that it should start looking for the file/directory relative to the current directory.",
                ancorName:"Relative Links",
                popup1Name:"relative link",
                popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653643895/msbGeanologyProfilePics/relative_link_td1h2t.png",
                popup2Name:"absolute link",
                popup2:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644249/msbGeanologyProfilePics/absolutlink_vmo5o6.png",
                },
                {
                name:'A Metaphor',
                detail:"Absolute and relative links are a tricky concept to build a good mental model of, a metaphor may help:",
                detail1:"Think of your domain name (town.com) as a town, the directory in which your website is located (/museum) as a museum, and each page on your website as a room in the museum (/museum/movie_room.html and /museum/shops/coffee_shop.html). Relative links like ./shops/coffee_shop.html are directions from the current room (the museum movie room /museum/movie_room.html) to another room (the museum shop). Absolute links, on the other hand, are full directions including the protocol (https), domain name (town.com) and the path from that domain name (/museum/shops/coffee_shop.html): https://town.com/museum/shops/coffee_shop.html.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"A Metaphor",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Images',
                detail:"Websites would be fairly boring if they could only display text. Luckily HTML provides a wide variety of elements for displaying all sorts of different media. The most widely used of these is the image element.",
                detail1:"To display an image in HTML we use the <img> element. Unlike the other elements we have encountered so far, the <img> element is empty. Which means it doesn’t have a closing tag.",
                detail2:"Instead of wrapping content with an opening and closing tag, it embeds an image into the page using a src attribute which tells the browser where the image file is located. The src attribute works much like the href attribute for anchor tags. It can embed an image using both absolute and relative paths.",
                detail3:"For example, using an absolute path we can display an image located on The Odin Project site:",
                detail4:"To use images that we have on our own websites, we can use a relative path.",
                detail5:"1. Create a new directory named images within the odin-links-and-images project.",
                detail6:"2. Next, download this image and move it into the images directory we just created.(check the link to download in the source)",
                detail7:"3. Rename the image to dog.jpg.",
                detail8:"Finally add the image to the index.html file:",
                detail9:"Save the index.html file and open it in a browser to view Charles in all his glory.",
                ancorName:"Images",
                popup1Name:"image display",
                popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653644641/msbGeanologyProfilePics/images_aqfnin.png",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Parent Directories',
                detail:"What if we want to use the dog image in the about page? We would first have to go up one level out of the pages directory into its parent directory so we could then access the images directory.",
                detail1:"To go to the parent directory we need to use two dots in the relative filepath like this: ../. Let’s see this in action, within the body of the about.html file, add the following image below the heading we added earlier:",
                detail2:'<img src="../images/dog.jpg">',
                detail3:"To break this down:",
                detail4:"1. First, we are going to the parent directory of the pages directory which is odin-links-and-images.",
                detail5:"2. Then, from the parent directory, we can go into the images directory.",
                detail6:"3. Finally, we can access the dog.jpg file.",
                detail7:"Using the metaphor we used earlier, using ../ in a filepath is kind of like stepping out from the room you are currently in to the main hallway so you can go to another room.",
                ancorName:"Parent Directories",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                {
                name:'Alt attribute',
                detail:"Besides the src attribute, every image element should also have an alt (alternative text) attribute.",
                detail1:"The alt attribute is used to describe an image. It will be used in place of the image if it cannot be loaded. It is also used with screen readers to describe what the image is to visually impaired users.",
                detail2:"This is how the The Odin Project logo example we used earlier looks with an alt attribute included:",
                detail3:"As a bit of practice, add an alt attribute to the dog image we added to the odin-links-and-images project.",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Alt attribute",
                popup1Name:"alt atribute",
                popup1:"https://res.cloudinary.com/msb-geneasocial/image/upload/v1653646504/msbGeanologyProfilePics/image_atribute_ujkhst.png",
                popup2Name:"",
                popup2:"",
                },
                
                {
                name:'Assignment',
                detail:"Watch Kevin Powell’s HTML Links Video.",
                detail1:"Watch Kevin Powell’s HTML Images Video.",
                detail2:"Watch Kevin Powell’s File Structure Video.",
                detail3:"Read about the four main image formats that can be used on the web.",
                detail4:" ",
                detail5:"",
                detail6:"",
                ancorName:"Assignment",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                {
                name:'',
                detail:"",
                detail1:"",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                {
                title:"Watch Kevin Powell’s HTML Images Video",
                url:"https://www.youtube.com/watch?v=0xoztJCHpbQ&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=6"
                },
                {
                title:"Watch Kevin Powell’s File Structure Video.",
                url:"https://www.youtube.com/watch?v=ta3Oxx7Yqbo&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=7"
                },
                {
                title:"Read about the four main image formats that can be used on the web.",
                url:"https://www.internetingishard.com/html-and-css/links-and-images/#image-formats"
                },
                {
                title:"Interneting is hard’s treatment on HTML links and images",
                url:"https://www.internetingishard.com/html-and-css/links-and-images/"
                },
                {
                title:"What happened the day Google decided links including (/) were malware",
                url:"https://www.itpro.co.uk/609724/google-apologises-after-blacklisting-entire-internet"
                },
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  {
                    check:"What is an attribute?"
                  },
                  {
                    check:"What attribute tells links where to go to?"
                  },
                  {
                    check:"What is the difference between an absolute and relative link?"
                  },
                
                  {
                    check:"Which element is used to display an image?"
                  },
                  {
                    check:"What two attributes do images always need to have?"
                  },
                  {
                    check:"How do you access a parent directory in a filepath?"
                  },
                  {
                    check:"What are the four main image formats that you can use for images on the web?"
                  },
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[],
                
              },
              {
                name:"referals",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
               
                ],
                people:[],
                
              },
              {
                name:"social media",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
               
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                 
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                
                ],
                people:[],
                
              },
            ]
          },
          
        ]
      },
      {
        name:"Physical marketing",
        courseStatus:"Incomplete",
        
        courseNumber:"006",
        logo:logo2,
        menu:[
        {
        name:'Introduction',
        detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
        detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
        detail2:"",
        detail3:"",
        detail4:"",
        detail5:"",
        detail6:"",
        ancorName:"Introduction",
        popup1Name:"",
        popup1:"",
        popup2Name:"",
        popup2:"",
        },
        
        ],
        additionalRead:[
        {
        title:"Watch Kevin Powell’s HTML Links Video.",
        url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
        },
        
        ],
        KnowledgeCheck:[
          {
            check:"What element is used to create a link?"
          },
         
        ],
        source:[
        {
        name:"TheodinProject",
        link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
        },
        
        ],
        people:[],
        companyLevel4:[
          {
            name:"in-person Investors",
            courseStatus:"Incomplete",
            
            courseNumber:"006",
            logo:logo2,
            menu:[
            {
            name:'Introduction',
            detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
            detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Introduction",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            
            ],
            additionalRead:[
            {
            title:"Watch Kevin Powell’s HTML Links Video.",
            url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
            },
            
            ],
            KnowledgeCheck:[
              {
                check:"What element is used to create a link?"
              },
              
            ],
            source:[
            {
            name:"TheodinProject",
            link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
            },
            {
            name:"download image ",
            link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
            },
            ],
            people:[],
            companyLevel5:[
              {
                name:"email",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
               
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                
                ],
                people:[],
                
              },
              {
                name:"referals",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
               
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                
                ],
                people:[],
                
              },
              {
                name:"social media",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
               
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                {
                name:"download image ",
                link:"https://unsplash.com/photos/Mv9hjnEUHR4/download?force=true&w=640"
                },
                ],
                people:[],
                
              },
            ]
          },
          {
            name:"in-person Events",
            courseStatus:"Incomplete",
            
            courseNumber:"006",
            logo:logo2,
            menu:[
            {
            name:'Introduction',
            detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
            detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
            detail2:"",
            detail3:"",
            detail4:"",
            detail5:"",
            detail6:"",
            ancorName:"Introduction",
            popup1Name:"",
            popup1:"",
            popup2Name:"",
            popup2:"",
            },
            
            ],
            additionalRead:[
            {
            title:"Watch Kevin Powell’s HTML Links Video.",
            url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
            },
            
            ],
            KnowledgeCheck:[
              {
                check:"What element is used to create a link?"
              },
              
            ],
            source:[
            {
            name:"TheodinProject",
            link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
            },
            
            ],
            people:[],
            companyLevel5:[
              {
                name:"email",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                  
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                
                ],
                people:[],
                
              },
              {
                name:"referals",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                 
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                
                ],
                people:[],
                
              },
              {
                name:"social media",
                courseStatus:"Incomplete",
                
                courseNumber:"006",
                logo:logo2,
                menu:[
                {
                name:'Introduction',
                detail:"Links are one of the key features of HTML. They allow us to link to other HTML pages on the web. In fact, this is why it’s called the web.",
                detail1:"In this lesson, we will learn how to create links and add some visual flair to our websites by embedding images.",
                detail2:"",
                detail3:"",
                detail4:"",
                detail5:"",
                detail6:"",
                ancorName:"Introduction",
                popup1Name:"",
                popup1:"",
                popup2Name:"",
                popup2:"",
                },
                
                ],
                additionalRead:[
                {
                title:"Watch Kevin Powell’s HTML Links Video.",
                url:"https://www.youtube.com/watch?v=tsEQgGjSmkM&list=PL4-IK0AVhVjM0xE0K2uZRvsM7LkIhsPT-&index=5"
                },
                
                ],
                KnowledgeCheck:[
                  {
                    check:"What element is used to create a link?"
                  },
                 
                ],
                source:[
                {
                name:"TheodinProject",
                link:"https://www.theodinproject.com/lessons/foundations-introduction-to-web-development"
                },
                
                ],
                people:[],
                
              },
            ]
          },
        ]
      },
    ]
  },
]
},
    
  ]
}


]
